import { RootState } from "app/store";
import { EControlType } from "components/ControlWrapper";
import { calcFieldName, friendlyValue } from "global/Application";
import { AppDataSource } from "global/DataSources/AppDataSource";
import {
    IBenefit as FAM_IBenefit,
    IEntityReferenceValue as FAM_IEntityReferenceValue,
    IFlexibleFieldSet as FAM_IFlexibleFieldSet,
    IGroupConfigurationData as FAM_IGroupConfigurationData,
    INonStandard as FAM_INonStandard,
    IPlan as FAM_IPlan
} from "model/FlexibleAttributeModel";
import { EColumnExtractDataTypes } from "./EColumnExtractDataTypes";
import { IColumnExtract } from "./IColumnExtract.type";
import { IDatasetExtract } from "./IDatasetExtract";
import { IRowExtract } from "./IRowExtract.type";
import { IAccountExtended } from "model/CRM.type";
import { ArrayToLookupByPredicate, ArrayToLookupByPredicateWithMap, formatDate, parseDate } from "global/Utility/TSFunctions";
import { $att_$accounts_receivable_$bcbs_cecapamount_ar_id, $att_$accounts_receivable_$bcbs_claims_ar_healthoptions_id, $att_$accounts_receivable_$bcbs_claims_ar_instatenationalcappedat_id, $att_$accounts_receivable_$bcbs_claims_ar_oospercentofsavings_id, $att_$accounts_receivable_$bcbs_claims_ar_oossharedsavingsotheramount_id, $att_$accounts_receivable_$bcbs_claims_ar_outofstatesavingsenter_id, $att_$accounts_receivable_$bcbs_claims_ar_percentofsavings_id, $att_$accounts_receivable_$bcbs_claims_ar_sharedsavingscapotheramount_id, $att_$accounts_receivable_$bcbs_claims_ar_sharedsavingscappedat_id, $att_$accounts_receivable_$bcbs_claims_armginstateotheramount_id, $att_$accounts_receivable_$bcbs_claims_armgoosotheramount_id, $att_$accounts_receivable_$bcbs_claims_aroossharedsavingscappedat_id, $att_$accounts_receivable_$bcbs_claims_aroutofstatenationalcappedat_id, $att_$accounts_receivable_$bcbs_claims_arpassprintaccessfeedataonweekly_id, $att_$accounts_receivable_$bcbs_claims_arprintsummaryonweeklyclaimsdetail_id, $att_$accounts_receivable_$bcbs_claimsar_claimscontact_id, $att_$accounts_receivable_$bcbs_claimsar_pfabreportcontact_id, $att_$accounts_receivable_$bcbs_claimsar_stoplosscontact_id, $att_$accounts_receivable_$bcbs_claimsbillingfrequency_id, $att_$accounts_receivable_$bcbs_contact_id, $att_$accounts_receivable_$bcbs_customadminpcpmreimbursedthroughcbf_id, $att_$accounts_receivable_$bcbs_displayssceline_ar_id, $att_$accounts_receivable_$bcbs_ebillinvoicecontactcode_id, $att_$accounts_receivable_$bcbs_fin_fees_blue_nat_access_fees_fl_id, $att_$accounts_receivable_$bcbs_fin_fees_blue_nat_admin_fees_fl_id, $att_$accounts_receivable_$bcbs_fin_fees_travel_ooa_access_pass_group_fl_id, $att_$accounts_receivable_$bcbs_fin_fees_travel_ooa_admin_pass_group_fl_id, $att_$accounts_receivable_$bcbs_fin_fin_report_ceiling_100_pec_id, $att_$accounts_receivable_$bcbs_fin_fin_report_ceiling_cost_id, $att_$accounts_receivable_$bcbs_fin_fin_report_ceiling_id, $att_$accounts_receivable_$bcbs_fin_fin_report_summary_rpt_id, $att_$accounts_receivable_$bcbs_fin_int_chrgs_late_pay_per_id, $att_$accounts_receivable_$bcbs_fin_payments_method_claims_bank_id, $att_$accounts_receivable_$bcbs_fin_payments_method_claims_id, $att_$accounts_receivable_$bcbs_fin_payments_method_claims_wire_id, $att_$accounts_receivable_$bcbs_fin_term_bill_to_id, $att_$accounts_receivable_$bcbs_fin_term_fee_admin_months_billed_id, $att_$accounts_receivable_$bcbs_fin_term_fee_comments_id, $att_$accounts_receivable_$bcbs_fin_term_fee_designation_id, $att_$accounts_receivable_$bcbs_fin_term_fee_mg_per_of_claim_id, $att_$accounts_receivable_$bcbs_fin_term_fee_partner_plan_id, $att_$accounts_receivable_$bcbs_fin_term_fee_sc_id, $att_$accounts_receivable_$bcbs_fin_term_fee_total_admin_id, $att_$accounts_receivable_$bcbs_instatesavingsenter_id, $att_$accounts_receivable_$bcbs_iprpcebillgroup_ar_id, $att_$accounts_receivable_$bcbs_pai_claimspayment_id, $att_$accounts_receivable_$bcbs_perscript_bccadminid_id, $att_$accounts_receivable_$bcbs_perscript_feeamount_id, $att_$accounts_receivable_$bcbs_perscript_feetype_id, $att_$accounts_receivable_$bcbs_perscript_guaranteeenddate_id, $att_$accounts_receivable_$bcbs_perscript_guaranteestartdate_id, $att_$accounts_receivable_$bcbs_perscript_onsite_id, $att_$accounts_receivable_$bcbs_printsummaryonweeklyclaimsdetail_id, $att_$fees_and_premiums_$bcbs_bccadminid_id, $att_$fees_and_premiums_$bcbs_billgroupcode_id, $att_$fees_and_premiums_$bcbs_dental_effective_date_id, $att_$fees_and_premiums_$bcbs_fee_feeamount_id, $att_$fees_and_premiums_$bcbs_fee_feetype_id, $att_$fees_and_premiums_$bcbs_fee_otherfeetype_id, $att_$fees_and_premiums_$bcbs_fin_curr_contr_yr_beginning_date_id, $att_$fees_and_premiums_$bcbs_fin_curr_contr_yr_end_date_id, $att_$fees_and_premiums_$bcbs_fin_curr_contr_yr_lob_eff_date_id, $att_$fees_and_premiums_$bcbs_medical_effective_date_id, $att_$fees_and_premiums_$bcbs_other_effective_date_id, $att_$fees_and_premiums_$bcbs_rx_effective_date_id, $att_$fees_and_premiums_$bcbs_scothersplit_id, $att_$fees_and_premiums_$bcbs_showasseparateitemonbill_id, $att_$fees_and_premiums_$bcbs_vision_effective_date_id, $att_$group_configuration_$bcbs_contract_end_date_id, $att_$group_configuration_$bcbs_fin_financialrecordsforbenefityear_e95ff1471414ed11b83d000d3a58ea31_id, $att_$group_configuration_$bcbs_fin_implementationnotesandcomments_0979c03f14e8ec11bb3c000d3a5a370f_id, $att_$group_configuration_$bcbs_fin_payments_adv_deposits_id, $att_$group_configuration_$bcbs_fin_payments_adv_deposits_yes_amt_id, $att_$group_configuration_$bcbs_finnumberofarclaimsrecordsrequired_id, $att_$group_configuration_$bcbs_legalgroupname_id, $att_$group_configuration_$bcbs_payrunoutclaims_id, $att_$group_configuration_$bcbs_payrunoutclaimshowmanymonths_id, $att_$group_configuration_$bcbs_runoutclaimsenddate_id, $att_$group_configuration_$bcbs_runoutverification_id, $att_$group_configuration_$bcbs_stoplosspending_id, $att_$stop_loss_$bcbs_adminfeesreinsurerid_id, $att_$stop_loss_$bcbs_claimant_type_laser_excluded_id, $att_$stop_loss_$bcbs_drugsoncarveouttablecode_id, $att_$stop_loss_$bcbs_fin_agg_spec_ded_add_liab_id, $att_$stop_loss_$bcbs_fin_agg_spec_ded_enroll_id, $att_$stop_loss_$bcbs_fin_agg_stop_loss_contract_basis_id, $att_$stop_loss_$bcbs_fin_agg_stop_loss_contract_basis_other_id, $att_$stop_loss_$bcbs_fin_agg_stop_loss_cov_includes_drug_id, $att_$stop_loss_$bcbs_fin_agg_stop_loss_cov_includes_med_id, $att_$stop_loss_$bcbs_fin_agg_stop_loss_cov_includes_vision_id, $att_$stop_loss_$bcbs_fin_agg_stop_loss_enroll_id, $att_$stop_loss_$bcbs_fin_att_points_att_point_id, $att_$stop_loss_$bcbs_fin_att_points_dental_eech_id, $att_$stop_loss_$bcbs_fin_att_points_dental_eesp_id, $att_$stop_loss_$bcbs_fin_att_points_dental_family_id, $att_$stop_loss_$bcbs_fin_att_points_dental_single_id, $att_$stop_loss_$bcbs_fin_att_points_drug_eech_id, $att_$stop_loss_$bcbs_fin_att_points_drug_eesp_id, $att_$stop_loss_$bcbs_fin_att_points_drug_family_id, $att_$stop_loss_$bcbs_fin_att_points_drug_single_id, $att_$stop_loss_$bcbs_fin_att_points_mim_ann_att_point_id, $att_$stop_loss_$bcbs_fin_att_points_ppo_eech_id, $att_$stop_loss_$bcbs_fin_att_points_ppo_eesp_id, $att_$stop_loss_$bcbs_fin_att_points_ppo_family_id, $att_$stop_loss_$bcbs_fin_att_points_ppo_single_id, $att_$stop_loss_$bcbs_fin_att_points_ppo_tp_id, $att_$stop_loss_$bcbs_fin_att_points_vision_eech_id, $att_$stop_loss_$bcbs_fin_att_points_vision_eesp_id, $att_$stop_loss_$bcbs_fin_att_points_vision_family_id, $att_$stop_loss_$bcbs_fin_att_points_vision_single_id, $att_$stop_loss_$bcbs_fin_spec_stop_loss_access_fee_id, $att_$stop_loss_$bcbs_fin_spec_stop_loss_carveout_drug_id, $att_$stop_loss_$bcbs_fin_spec_stop_loss_contr_basis_id, $att_$stop_loss_$bcbs_fin_spec_stop_loss_contr_basis_other_id, $att_$stop_loss_$bcbs_fin_spec_stop_loss_cov_dental_id, $att_$stop_loss_$bcbs_fin_spec_stop_loss_cov_drug_id, $att_$stop_loss_$bcbs_fin_spec_stop_loss_cov_medical_id, $att_$stop_loss_$bcbs_fin_spec_stop_loss_cov_vision_id, $att_$stop_loss_$bcbs_fin_spec_stop_loss_ded_amt_id, $att_$stop_loss_$bcbs_fin_spec_stop_loss_pbm_vendorid_id, $att_$stop_loss_$bcbs_fin_stop_loss_begin_date_id, $att_$stop_loss_$bcbs_fin_stop_loss_end_date_id, $att_$stop_loss_$bcbs_laserclaimantfirstname_id, $att_$stop_loss_$bcbs_laserclaimantlastname_id, $att_$stop_loss_$bcbs_lasercontractbasis_id, $att_$stop_loss_$bcbs_laserdob_id, $att_$stop_loss_$bcbs_laserspecificdedamt_id, $att_$stop_loss_$bcbs_otherreinsurerid_id, $att_$stop_loss_$bcbs_releasecredits_id, $att_$stop_loss_$bcbs_stoplosscompany_id, $att_$stop_loss_$bcbs_stoplossemail_id, $att_$stop_loss_$bcbs_stoplosspacketname_id, $att_$stop_loss_$bcbs_subssnaltid_id } from "model/ConfigAttributeConstants";
import { $matt_$accounts_receivable_$bcbs_attributeset_claimsarcontact_id, $matt_$accounts_receivable_$bcbs_attributeset_perscriptfee_id, $matt_$fees_and_premiums_$bcbs_attributeset_fee_id, $matt_$stop_loss_$bcbs_laseredindividuals_id, $matt_$stop_loss_$bcbs_stoplosspackets_id } from "model/MasterAttributeConstants";


interface INonstandardToRowScope {
    groupConfig: FAM_IGroupConfigurationData;
    plan?: FAM_IPlan;
    benefit?: FAM_IBenefit;
    nonStandard: FAM_INonStandard;
}

export default async function PFABExcelExtract(state: RootState, dataSource: AppDataSource) {
    const rows: IRowExtract[] = [];
    const columns: Record<string, IColumnExtract> = {};
    let columnIX = 0;
    const claimsarrows: IRowExtract[] = [];
    const perscriptrows: IRowExtract[] = [];
    const contactrows: IRowExtract[] = [];
    const datapacketrows: IRowExtract[] = [];
    const stoplossrows: IRowExtract[] = [];
    const laseredrows: IRowExtract[] = [];
    const fprows: IRowExtract[] = [];
    const claimsarcolumns: Record<string, IColumnExtract> = {};
    const perscriptcolumns: Record<string, IColumnExtract> = {};
    const contactcolumns: Record<string, IColumnExtract> = {};
    const stoplosscolumns: Record<string, IColumnExtract> = {};
    const datapacketcolumns: Record<string, IColumnExtract> = {};
    const laseredcolumns: Record<string, IColumnExtract> = {};
    const fpcolumns: Record<string, IColumnExtract> = {};
    let claimsarcolumnIX = 0;
    let contactcolumnIX = 0;
    let stoplosscolumnIX = 0;
    let datapacketcolumnIX = 0;
    let laseredcolumnIX = 0;
    let fpcolumnIX = 0;
    //type TContact = { contactid: string, fullname: string, emailaddress1: string };
    //let contactLookupResultFinal: Record<string, TContact> = {};



    function getFeeValues(fee: FAM_IFlexibleFieldSet[]) {
        let returnValues: string[] = [];
        const feeFields = ArrayToLookupByPredicateWithMap(fee[0].fields, t => t.configRef.id, t => {
            const attribute = state.data.config.cache.map_bcbs_config_attribute[t.configRef.id];
            const masterAttribute = state.data.config.cache.map_bcbs_config_masterattribute[attribute._bcbs_config_masterattributeid_value!];
            const controlType = masterAttribute.bcbs_attributetypecode as EControlType;
            return {
                field: t,
                attribute,
                masterAttribute,
                controlType,
            }
        });
        const feeType = feeFields[$att_$fees_and_premiums_$bcbs_fee_feetype_id];
        const feeAmount = feeFields[$att_$fees_and_premiums_$bcbs_fee_feeamount_id];
        if (feeType.field.values[0].value !== null)
            returnValues[0] = friendlyValue(feeType.controlType, feeType.field.values[0].value);
        else
            returnValues[0] = "";
        if (feeAmount.field.values[0].value !== null) {
            if (friendlyValue(feeAmount.controlType, feeAmount.field.values[0].value) !== "0" && friendlyValue(feeAmount.controlType, feeAmount.field.values[0].value) !== "0.00")
                returnValues[1] = friendlyValue(feeAmount.controlType, feeAmount.field.values[0].value);
        }
        else
            returnValues[1] = "";


        return returnValues;
    }


    columns['groupName'] = {
        attributeId: '',
        order: 0,
        width: 25,
        index: ++columnIX,
        fieldName: 'groupName',
        hidden: false,
        name: 'Group Name',
        dataType: EColumnExtractDataTypes.Default,
    };

    //columns['ar'] = {
    //    attributeId: '',
    //    order: 0,
    //    width: 25,
    //    index: ++columnIX,
    //    fieldName: 'ar',
    //    hidden: false,
    //    name: 'AR',
    //    dataType: EColumnExtractDataTypes.Default,
    //};

    //columns['stoploss'] = {
    //    attributeId: '',
    //    order: 0,
    //    width: 18,
    //    index: ++columnIX,
    //    fieldName: 'stoploss',
    //    hidden: false,
    //    name: 'Stop Loss',
    //    dataType: EColumnExtractDataTypes.Default,
    //};

    //columns['prefixbase'] = {
    //    attributeId: '',
    //    order: 0,
    //    width: 18,
    //    index: ++columnIX,
    //    fieldName: 'prefixbase',
    //    hidden: false,
    //    name: 'Prefix-Base',
    //    dataType: EColumnExtractDataTypes.Default,
    //};

    //columns['suffixes'] = {
    //    attributeId: '',
    //    order: 0,
    //    width: 38,
    //    index: ++columnIX,
    //    fieldName: 'suffixes',
    //    hidden: false,
    //    name: 'Suffix(es)',
    //    dataType: EColumnExtractDataTypes.Default,
    //};

    columns['effectiveDate'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++columnIX,
        fieldName: 'effectiveDate',
        hidden: false,
        name: 'Effective Date',
        dataType: EColumnExtractDataTypes.Default,
    };

    columns['benefitYearStart'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++columnIX,
        fieldName: 'benefitYearStart',
        hidden: false,
        name: 'Financial Records for Benefit Year Starting',
        dataType: EColumnExtractDataTypes.Default,
    };

    columns['contractEndDate'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++columnIX,
        fieldName: 'contractEndDate',
        hidden: false,
        name: 'Contract End Date',
        dataType: EColumnExtractDataTypes.Default,
    };

    columns['recordStatus'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++columnIX,
        fieldName: 'recordStatus',
        hidden: false,
        name: 'Record Status',
        dataType: EColumnExtractDataTypes.Default,
    };

    columns['advancedDeposits'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++columnIX,
        fieldName: 'advancedDeposits',
        hidden: false,
        name: 'Advanced Deposits',
        dataType: EColumnExtractDataTypes.Default,
    };
    /*
    columns['advancedDeposits'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++columnIX,
        fieldName: 'advancedDeposits',
        hidden: false,
        name: 'Advanced Deposits',
        dataType: EColumnExtractDataTypes.Default,
    };
    */

    columns['enterAmount'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++columnIX,
        fieldName: 'enterAmount',
        hidden: false,
        name: 'Enter Amount',
        dataType: EColumnExtractDataTypes.Default,
    };

    columns['stopLossPending'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++columnIX,
        fieldName: 'stopLossPending',
        hidden: false,
        name: 'Stop Loss Pending?',
        dataType: EColumnExtractDataTypes.Default,
    };

    columns['gcNotes'] = {
        attributeId: '',
        order: 0,
        width: 35,
        index: ++columnIX,
        fieldName: 'gcNotes',
        hidden: false,
        name: 'GC Notes and Comments',
        dataType: EColumnExtractDataTypes.Default,
    };

    columns['numberofClaimsARRecordsRequired'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++columnIX,
        fieldName: 'numberofClaimsARRecordsRequired',
        hidden: false,
        name: 'Number of AR Claims records required',
        dataType: EColumnExtractDataTypes.Default,
    };

    columns['cancellationEffectiveDate'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++columnIX,
        fieldName: 'cancellationEffectiveDate',
        hidden: false,
        name: 'Cancellation Effective Date',
        dataType: EColumnExtractDataTypes.Default,
    };

    columns['payRunOutClaims'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++columnIX,
        fieldName: 'payRunOutClaims',
        hidden: false,
        name: 'Pay Run Out Claims',
        dataType: EColumnExtractDataTypes.Default,
    };

    columns['payRunOutClaimsHowManyMonths'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++columnIX,
        fieldName: 'payRunOutClaimsHowManyMonths',
        hidden: false,
        name: 'Pay Run Out Claims How Many Months',
        dataType: EColumnExtractDataTypes.Default,
    };

    columns['runOutClaimsEndDate'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++columnIX,
        fieldName: 'runOutClaimsEndDate',
        hidden: false,
        name: 'Run Out Claims End Date',
        dataType: EColumnExtractDataTypes.Default,
    };

    columns['runOutTermsVerification'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++columnIX,
        fieldName: 'runOutTermsVerification',
        hidden: false,
        name: 'Run Out Terms Have Been Verified',
        dataType: EColumnExtractDataTypes.Default,
    };

    claimsarcolumns['ARClaimsARName'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++claimsarcolumnIX,
        fieldName: 'ARClaimsARName',
        hidden: false,
        name: 'Claims AR - AR Name',
        dataType: EColumnExtractDataTypes.Default,
    };

    claimsarcolumns['ARprefixbase'] = {
        attributeId: '',
        order: 0,
        width: 18,
        index: ++claimsarcolumnIX,
        fieldName: 'ARprefixbase',
        hidden: false,
        name: 'AR - Prefix-Base',
        dataType: EColumnExtractDataTypes.Default,
    };

    claimsarcolumns['ARsuffixes'] = {
        attributeId: '',
        order: 0,
        width: 38,
        index: ++claimsarcolumnIX,
        fieldName: 'ARsuffixes',
        hidden: false,
        name: 'AR - Suffix(es)',
        dataType: EColumnExtractDataTypes.Default,
    };

    claimsarcolumns['ARmethodofpaymentclaims'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++claimsarcolumnIX,
        fieldName: 'ARmethodofpaymentclaims',
        hidden: false,
        name: 'Method of Payment (Claims)',
        dataType: EColumnExtractDataTypes.Default,
    };

    claimsarcolumns['ARbankdraft'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++claimsarcolumnIX,
        fieldName: 'ARbankdraft',
        hidden: false,
        name: 'Bank Draft',
        dataType: EColumnExtractDataTypes.Default,
    };

    claimsarcolumns['ARwiretransferACH'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++claimsarcolumnIX,
        fieldName: 'ARwiretransferACH',
        hidden: false,
        name: 'Wire Transfer / ACH',
        dataType: EColumnExtractDataTypes.Default,
    };

    claimsarcolumns['ARPAI'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++claimsarcolumnIX,
        fieldName: 'ARPAI',
        hidden: false,
        name: 'PAI',
        dataType: EColumnExtractDataTypes.Default,
    };

    claimsarcolumns['ARClaimsBillingFrequency'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++claimsarcolumnIX,
        fieldName: 'ARClaimsBillingFrequency',
        hidden: false,
        name: 'Claims Billing Frequency',
        dataType: EColumnExtractDataTypes.Default,
    };

    claimsarcolumns['ARinterestChargesOnLatePayments'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++claimsarcolumnIX,
        fieldName: 'interestChargesOnLatePayments',
        hidden: false,
        name: 'Interest Charges on Late Payments (per month)%',
        dataType: EColumnExtractDataTypes.Default,
    };

    claimsarcolumns['ARterminationfeeaspercentageofclaim'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++claimsarcolumnIX,
        fieldName: 'ARterminationfeeaspercentageofclaim',
        hidden: false,
        name: 'Termination Fee as Percentage of Claim?',
        dataType: EColumnExtractDataTypes.Default,
    };

    claimsarcolumns['ARterminationfeeswillbepaidaspercentofclaim'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++claimsarcolumnIX,
        fieldName: 'ARterminationfeeswillbepaidaspercentofclaim',
        hidden: false,
        name: 'Termination Fees will be paid as percent of claim (% amount)',
        dataType: EColumnExtractDataTypes.Default,
    };

    claimsarcolumns['ARAdminMonthsBilled'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++claimsarcolumnIX,
        fieldName: 'ARAdminMonthsBilled',
        hidden: false,
        name: 'Admin Months Billed',
        dataType: EColumnExtractDataTypes.Default,
    };

    claimsarcolumns['ARTotalAdminFeeAmount'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++claimsarcolumnIX,
        fieldName: 'ARTotalAdminFeeAmount',
        hidden: false,
        name: 'Total Admin Fee Amount',
        dataType: EColumnExtractDataTypes.Default,
    };

    claimsarcolumns['ARSCLocalAdminAmount'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++claimsarcolumnIX,
        fieldName: 'ARSCLocalAdminAmount',
        hidden: false,
        name: 'SC/Local Admin Amount',
        dataType: EColumnExtractDataTypes.Default,
    };

    claimsarcolumns['ARPartnerPlanAmount'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++claimsarcolumnIX,
        fieldName: 'ARPartnerPlanAmount',
        hidden: false,
        name: 'Partner Plan Amount',
        dataType: EColumnExtractDataTypes.Default,
    };

    claimsarcolumns['ARBillTerminationFeesTo'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++claimsarcolumnIX,
        fieldName: 'ARBillTerminationFeesTo',
        hidden: false,
        name: 'Bill Termination Fees To',
        dataType: EColumnExtractDataTypes.Default,
    };

    claimsarcolumns['ARTerminationFeeComments'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++claimsarcolumnIX,
        fieldName: 'ARTerminationFeeComments',
        hidden: false,
        name: 'Termination Fee - Comments',
        dataType: EColumnExtractDataTypes.Default,
    };

    claimsarcolumns['ARBlueCardNationalAdminFeesPassthroughto'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++claimsarcolumnIX,
        fieldName: 'ARBlueCardNationalAdminFeesPassthroughto',
        hidden: false,
        name: 'Blue Card National Admin Fees Pass through to',
        dataType: EColumnExtractDataTypes.Default,
    };

    claimsarcolumns['ARTravelersOOAAdminFeesPassthroughto'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++claimsarcolumnIX,
        fieldName: 'ARTravelersOOAAdminFeesPassthroughto',
        hidden: false,
        name: 'Travelers (OOA) Admin Fees Pass through to',
        dataType: EColumnExtractDataTypes.Default,
    };

    claimsarcolumns['ARCustomAdminPCPMreimbursedthroughCBF'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++claimsarcolumnIX,
        fieldName: 'ARCustomAdminPCPMreimbursedthroughCBF',
        hidden: false,
        name: 'Custom Admin (PCPM) reimbursed through CBF',
        dataType: EColumnExtractDataTypes.Default,
    };

    claimsarcolumns['ARBlueCardNationalAccessFeesPassthroughto'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++claimsarcolumnIX,
        fieldName: 'ARBlueCardNationalAccessFeesPassthroughto',
        hidden: false,
        name: 'Blue Card National Access Fees Pass through to',
        dataType: EColumnExtractDataTypes.Default,
    };

    claimsarcolumns['ARTravelersOOAAccessFeesPassthroughto'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++claimsarcolumnIX,
        fieldName: 'ARTravelersOOAAccessFeesPassthroughto',
        hidden: false,
        name: 'Travelers (OOA) Access Fees Pass through to',
        dataType: EColumnExtractDataTypes.Default,
    };

    claimsarcolumns['ARhealthOptions'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++claimsarcolumnIX,
        fieldName: 'healthOptions',
        hidden: false,
        name: 'Health Options',
        dataType: EColumnExtractDataTypes.Default,
    };


    //claimsarcolumns['ARterminationFeesWillBePaid'] = {
    //    attributeId: '',
    //    order: 0,
    //    width: 15,
    //    index: ++claimsarcolumnIX,
    //    fieldName: 'terminationFeesWillBePaid',
    //    hidden: false,
    //    name: 'Termination Fees will be paid as % of claim',
    //    dataType: EColumnExtractDataTypes.Default,
    //};

    //claimsarcolumns['ARComments'] = {
    //    attributeId: '',
    //    order: 0,
    //    width: 15,
    //    index: ++claimsarcolumnIX,
    //    fieldName: 'ARComments',
    //    hidden: false,
    //    name: 'AR Comments',
    //    dataType: EColumnExtractDataTypes.Default,
    //};

    claimsarcolumns['ARmgInStateOtherAmount'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++claimsarcolumnIX,
        fieldName: 'mgInStateOtherAmount',
        hidden: false,
        name: 'In-State Other Amount (MG)',
        dataType: EColumnExtractDataTypes.Default,
    };

    claimsarcolumns['ARinStateSavings'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++claimsarcolumnIX,
        fieldName: 'inStateSavings',
        hidden: false,
        name: 'In-State Savings (Enter %) (MG)',
        dataType: EColumnExtractDataTypes.Default,
    };

    claimsarcolumns['ARinStateCappedAtNA'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++claimsarcolumnIX,
        fieldName: 'inStateCappedAtNA',
        hidden: false,
        name: 'In-State Capped at NA',
        dataType: EColumnExtractDataTypes.Default,
    };

    claimsarcolumns['ARnaInStateOtherAmount'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++claimsarcolumnIX,
        fieldName: 'naInStateOtherAmount',
        hidden: false,
        name: 'In-State Other Amount (NA)',
        dataType: EColumnExtractDataTypes.Default,
    };

    claimsarcolumns['ARinStatePercentageOfSavings'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++claimsarcolumnIX,
        fieldName: 'inStatePercentageOfSavings',
        hidden: false,
        name: 'In-State % of Savings (NA)',
        dataType: EColumnExtractDataTypes.Default,
    };

    claimsarcolumns['ARinStateCappedAtMG'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++claimsarcolumnIX,
        fieldName: 'inStateCappedAtMG',
        hidden: false,
        name: 'In-State Capped at MG',
        dataType: EColumnExtractDataTypes.Default,
    };

    claimsarcolumns['ARmgOutOfStateOtherAmount'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++claimsarcolumnIX,
        fieldName: 'mgOutOfStateOtherAmount',
        hidden: false,
        name: 'Out-of-State Other Amount (MG)',
        dataType: EColumnExtractDataTypes.Default,
    };

    claimsarcolumns['ARoutOfStateSavings'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++claimsarcolumnIX,
        fieldName: 'outOfStateSavings',
        hidden: false,
        name: 'Out-of-State Savings (Enter %) (MG)',
        dataType: EColumnExtractDataTypes.Default,
    };

    claimsarcolumns['ARoutOfStateCappedAtNA'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++claimsarcolumnIX,
        fieldName: 'outOfStateCappedAtNA',
        hidden: false,
        name: 'Out-of-State Capped at NA',
        dataType: EColumnExtractDataTypes.Default,
    };

    claimsarcolumns['ARnaOutOfStateOtherAmount'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++claimsarcolumnIX,
        fieldName: 'naOutOfStateOtherAmount',
        hidden: false,
        name: 'Out-of-State Other Amount (NA)',
        dataType: EColumnExtractDataTypes.Default,
    };

    claimsarcolumns['ARoutOfStatePercentageOfSavings'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++claimsarcolumnIX,
        fieldName: 'outOfStatePercentageOfSavings',
        hidden: false,
        name: 'Out-of-State % of Savings (NA)',
        dataType: EColumnExtractDataTypes.Default,
    };

    claimsarcolumns['ARoutOfStateCappedAtMG'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++claimsarcolumnIX,
        fieldName: 'outOfStateCappedAtMG',
        hidden: false,
        name: 'Out-of-State Capped at MG',
        dataType: EColumnExtractDataTypes.Default,
    };

    claimsarcolumns['ARprintsummaryonweeklyclaimsdetailMG'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++claimsarcolumnIX,
        fieldName: 'ARprintsummaryonweeklyclaimsdetailMG',
        hidden: false,
        name: 'Print summary on weekly claims detail? (MG)',
        dataType: EColumnExtractDataTypes.Default,
    };

    claimsarcolumns['ARprintsummaryonweeklyclaimsdetailNA'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++claimsarcolumnIX,
        fieldName: 'ARprintsummaryonweeklyclaimsdetailNA',
        hidden: false,
        name: 'Print summary on weekly claims detail? (NA)',
        dataType: EColumnExtractDataTypes.Default,
    };

    claimsarcolumns['ARprintAccessFeeDataOnWeeklyClaimsDetail'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++claimsarcolumnIX,
        fieldName: 'printAccessFeeDataOnWeeklyClaimsDetail',
        hidden: false,
        name: 'Print access fee data on weekly claims detail?',
        dataType: EColumnExtractDataTypes.Default,
    };

    claimsarcolumns['ARceilingLimitReport'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++claimsarcolumnIX,
        fieldName: 'ceilingLimitReport',
        hidden: false,
        name: 'Ceiling Limit Report',
        dataType: EColumnExtractDataTypes.Default,
    };

    claimsarcolumns['ARceilingLimitReportIfYesEnterAmount'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++claimsarcolumnIX,
        fieldName: 'ceilingLimitReportIfYesEnterAmount',
        hidden: false,
        name: 'Ceiling Limit Report - If Yes, enter amount',
        dataType: EColumnExtractDataTypes.Default,
    };

    //claimsarcolumns['ARfiftyPercentOfSpecificStopLoss'] = {
    //    attributeId: '',
    //    order: 0,
    //    width: 15,
    //    index: ++claimsarcolumnIX,
    //    fieldName: 'fiftyPercentOfSpecificStopLoss',
    //    hidden: false,
    //    name: '50% of Specific Stop Loss',
    //    dataType: EColumnExtractDataTypes.Default,
    //};

    claimsarcolumns['ARoneHundredPercentOfSpecificStopLoss'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++claimsarcolumnIX,
        fieldName: 'oneHundredPercentOfSpecificStopLoss',
        hidden: false,
        name: '50/100% of Specific Stop Loss',
        dataType: EColumnExtractDataTypes.Default,
    };

    claimsarcolumns['ARsummaryReportPFAB400'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++claimsarcolumnIX,
        fieldName: 'summaryReportPFAB400',
        hidden: false,
        name: 'Summary Report (PFAB 400)',
        dataType: EColumnExtractDataTypes.Default,
    };

    claimsarcolumns['ARIPRPClaimsEditBillGroup'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++claimsarcolumnIX,
        fieldName: 'ARIPRPClaimsEditBillGroup',
        hidden: false,
        name: 'IPRP - Claims Edit Bill Group',
        dataType: EColumnExtractDataTypes.Default,
    };

    claimsarcolumns['ARIPRPDisplayClaimsEditOnBill'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++claimsarcolumnIX,
        fieldName: 'ARIPRPDisplayClaimsEditOnBill',
        hidden: false,
        name: 'Display IPRP Claims Edit on Bill',
        dataType: EColumnExtractDataTypes.Default,
    };

    claimsarcolumns['ARIPRPClaimsEditCapAmount'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++claimsarcolumnIX,
        fieldName: 'ARIPRPClaimsEditCapAmount',
        hidden: false,
        name: 'Claims Edit Cap Amount',
        dataType: EColumnExtractDataTypes.Default,
    };

    perscriptcolumns['PerScriptARName'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++claimsarcolumnIX,
        fieldName: 'PerScriptARName',
        hidden: false,
        name: 'Claims AR - AR Name',
        dataType: EColumnExtractDataTypes.Default,
    };

    perscriptcolumns['PerScriptBCC'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++claimsarcolumnIX,
        fieldName: 'PerScriptBCC',
        hidden: false,
        name: 'BCC Admin',
        dataType: EColumnExtractDataTypes.Default,
    };

    perscriptcolumns['PerScriptFeeType'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++claimsarcolumnIX,
        fieldName: 'PerScriptFeeType',
        hidden: false,
        name: 'Fee Type',
        dataType: EColumnExtractDataTypes.Default,
    };

    perscriptcolumns['PerScriptFeeAmount'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++claimsarcolumnIX,
        fieldName: 'PerScriptFeeAmount',
        hidden: false,
        name: 'Fee Amount',
        dataType: EColumnExtractDataTypes.Default,
    };

    perscriptcolumns['PerScriptOnsite'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++claimsarcolumnIX,
        fieldName: 'PerScriptOnsite',
        hidden: false,
        name: 'Onsite',
        dataType: EColumnExtractDataTypes.Default,
    };

    perscriptcolumns['PerScriptGuaranteeStartDate'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++claimsarcolumnIX,
        fieldName: 'PerScriptGuaranteeStartDate',
        hidden: false,
        name: 'Guarantee Start Date',
        dataType: EColumnExtractDataTypes.Default,
    };

    perscriptcolumns['PerScriptGuaranteeEndDate'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++claimsarcolumnIX,
        fieldName: 'PerScriptGuaranteeEndDate',
        hidden: false,
        name: 'Guarantee End Date',
        dataType: EColumnExtractDataTypes.Default,
    };

    contactcolumns['arcontactgroupname'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++contactcolumnIX,
        fieldName: 'arcontactgroupname',
        hidden: false,
        name: 'Contact - Group Name',
        dataType: EColumnExtractDataTypes.Default,
    };

    contactcolumns['contactname'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++contactcolumnIX,
        fieldName: 'contactname',
        hidden: false,
        name: 'Contact - AR Name',
        dataType: EColumnExtractDataTypes.Default,
    };

    contactcolumns['arcontact99prefixbase'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++contactcolumnIX,
        fieldName: 'arcontact99prefixbase',
        hidden: false,
        name: '99 AR Number',
        dataType: EColumnExtractDataTypes.Default,
    };

    contactcolumns['contact'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++contactcolumnIX,
        fieldName: 'contact',
        hidden: false,
        name: 'Contact',
        dataType: EColumnExtractDataTypes.Default,
    };

    contactcolumns['claimsPHIContact'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++contactcolumnIX,
        fieldName: 'claimsPHIContact',
        hidden: false,
        name: 'Claims PHI Contact',
        dataType: EColumnExtractDataTypes.Default,
    };

    contactcolumns['ceilingLimitContact'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++contactcolumnIX,
        fieldName: 'ceilingLimitContact',
        hidden: false,
        name: '50/100% Stop Loss/Ceiling Limit Contact',
        dataType: EColumnExtractDataTypes.Default,
    };

    contactcolumns['PFAB400ReportContact'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++contactcolumnIX,
        fieldName: 'PFAB400ReportContact',
        hidden: false,
        name: 'PFAB 400 Report Contact',
        dataType: EColumnExtractDataTypes.Default,
    };

    contactcolumns['eBillInvoiceContact'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++contactcolumnIX,
        fieldName: 'eBillInvoiceContact',
        hidden: false,
        name: 'EBill Invoice Contact',
        dataType: EColumnExtractDataTypes.Default,
    };

    contactcolumns['contactemailaddress'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++contactcolumnIX,
        fieldName: 'contactemailaddress',
        hidden: false,
        name: 'Contact Email Address',
        dataType: EColumnExtractDataTypes.Default,
    };

    fpcolumns['FPName'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++fpcolumnIX,
        fieldName: 'FPName',
        hidden: false,
        name: 'FP - FP Name',
        dataType: EColumnExtractDataTypes.Default,
    };

    fpcolumns['FPprefixbase'] = {
        attributeId: '',
        order: 0,
        width: 18,
        index: ++fpcolumnIX,
        fieldName: 'FPprefixbase',
        hidden: false,
        name: 'FP - Prefix-Base',
        dataType: EColumnExtractDataTypes.Default,
    };

    fpcolumns['FPsuffixes'] = {
        attributeId: '',
        order: 0,
        width: 38,
        index: ++fpcolumnIX,
        fieldName: 'FPsuffixes',
        hidden: false,
        name: 'FP - Suffix(es)',
        dataType: EColumnExtractDataTypes.Default,
    };

    fpcolumns['FPBeginningDate'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++fpcolumnIX,
        fieldName: 'FPBeginningDate',
        hidden: false,
        name: 'Beginning Date',
        dataType: EColumnExtractDataTypes.Default,
    };

    fpcolumns['FPEndingDate'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++fpcolumnIX,
        fieldName: 'FPEndingDate',
        hidden: false,
        name: 'Ending Date',
        dataType: EColumnExtractDataTypes.Default,
    };

    fpcolumns['FPOriginalLOBGroupEffectiveDate'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++fpcolumnIX,
        fieldName: 'FPOriginalLOBGroupEffectiveDate',
        hidden: false,
        name: 'Original (LOB) Group Effective Date',
        dataType: EColumnExtractDataTypes.Default,
    };

    fpcolumns['FPMedicalEffectiveDate'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++fpcolumnIX,
        fieldName: 'FPMedicalEffectiveDate',
        hidden: false,
        name: 'Medical Effective Date',
        dataType: EColumnExtractDataTypes.Default,
    };

    fpcolumns['FPOtherEffectiveDate'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++fpcolumnIX,
        fieldName: 'FPOtherEffectiveDate',
        hidden: false,
        name: 'Other Effective Date',
        dataType: EColumnExtractDataTypes.Default,
    };

    fpcolumns['FPDentalEffectiveDate'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++fpcolumnIX,
        fieldName: 'FPDentalEffectiveDate',
        hidden: false,
        name: 'Dental Effective Date',
        dataType: EColumnExtractDataTypes.Default,
    };

    fpcolumns['FPRXEffectiveDate'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++fpcolumnIX,
        fieldName: 'FPRXEffectiveDate',
        hidden: false,
        name: 'Rx Effective Date',
        dataType: EColumnExtractDataTypes.Default,
    };

    fpcolumns['FPASOHealthyVisionEffectiveDate'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++fpcolumnIX,
        fieldName: 'FPASOHealthyVisionEffectiveDate',
        hidden: false,
        name: 'ASO Healthy Vision Effective Date',
        dataType: EColumnExtractDataTypes.Default,
    };

    fpcolumns['HRAFeeType'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++fpcolumnIX,
        fieldName: 'HRAFeeType',
        hidden: false,
        name: 'HRA Fee Type',
        dataType: EColumnExtractDataTypes.Default,
    };

    fpcolumns['HRAOtherFeeType'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++fpcolumnIX,
        fieldName: 'HRAOtherFeeType',
        hidden: false,
        name: 'HRA Other Fee Type',
        dataType: EColumnExtractDataTypes.Default,
    };

    fpcolumns['HRAFeeAmount'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++fpcolumnIX,
        fieldName: 'HRAFeeAmount',
        hidden: false,
        name: 'HRA Fee Amount',
        dataType: EColumnExtractDataTypes.Default,
    };

    fpcolumns['HRABillGroup'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++fpcolumnIX,
        fieldName: 'HRABillGroup',
        hidden: false,
        name: 'HRA Bill Group',
        dataType: EColumnExtractDataTypes.Default,
    };

    fpcolumns['HRAShowAsSeparateItemOnBill'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++fpcolumnIX,
        fieldName: 'HRAShowAsSeparateItemOnBill',
        hidden: false,
        name: 'HRA Show As Separate Item On Bill',
        dataType: EColumnExtractDataTypes.Default,
    };

    fpcolumns['HRABCBSSCOtherSplit'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++fpcolumnIX,
        fieldName: 'HRABCBSSCOtherSplit',
        hidden: false,
        name: 'HRA BCBSSC/Other Split',
        dataType: EColumnExtractDataTypes.Default,
    };

    fpcolumns['HRAComment'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++fpcolumnIX,
        fieldName: 'HRAComment',
        hidden: false,
        name: 'HRA Comment',
        dataType: EColumnExtractDataTypes.Default,
    };

    fpcolumns['CA1FeeType'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++fpcolumnIX,
        fieldName: 'CA1FeeType',
        hidden: false,
        name: 'CA1 Fee Type',
        dataType: EColumnExtractDataTypes.Default,
    };

    fpcolumns['CA1OtherFeeType'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++fpcolumnIX,
        fieldName: 'CA1OtherFeeType',
        hidden: false,
        name: 'CA1 Other Fee Type',
        dataType: EColumnExtractDataTypes.Default,
    };

    fpcolumns['CA1FeeAmount'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++fpcolumnIX,
        fieldName: 'CA1FeeAmount',
        hidden: false,
        name: 'CA1 Fee Amount',
        dataType: EColumnExtractDataTypes.Default,
    };

    fpcolumns['CA1BillGroup'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++fpcolumnIX,
        fieldName: 'CA1BillGroup',
        hidden: false,
        name: 'CA1 Bill Group',
        dataType: EColumnExtractDataTypes.Default,
    };

    fpcolumns['CA1ShowAsSeparateItemOnBill'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++fpcolumnIX,
        fieldName: 'CA1ShowAsSeparateItemOnBill',
        hidden: false,
        name: 'CA1 Show As Separate Item On Bill',
        dataType: EColumnExtractDataTypes.Default,
    };

    fpcolumns['CA1BCBSSCOtherSplit'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++fpcolumnIX,
        fieldName: 'CA1BCBSSCOtherSplit',
        hidden: false,
        name: 'CA1 BCBSSC/Other Split',
        dataType: EColumnExtractDataTypes.Default,
    };

    fpcolumns['CA1Comment'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++fpcolumnIX,
        fieldName: 'CA1Comment',
        hidden: false,
        name: 'CA1 Comment',
        dataType: EColumnExtractDataTypes.Default,
    };

    fpcolumns['BA1FeeType'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++fpcolumnIX,
        fieldName: 'BA1FeeType',
        hidden: false,
        name: 'BA1 Fee Type',
        dataType: EColumnExtractDataTypes.Default,
    };

    fpcolumns['BA1OtherFeeType'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++fpcolumnIX,
        fieldName: 'BA1OtherFeeType',
        hidden: false,
        name: 'BA1 Other Fee Type',
        dataType: EColumnExtractDataTypes.Default,
    };

    fpcolumns['BA1FeeAmount'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++fpcolumnIX,
        fieldName: 'BA1FeeAmount',
        hidden: false,
        name: 'BA1 Fee Amount',
        dataType: EColumnExtractDataTypes.Default,
    };

    fpcolumns['BA1BillGroup'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++fpcolumnIX,
        fieldName: 'BA1BillGroup',
        hidden: false,
        name: 'BA1 Bill Group',
        dataType: EColumnExtractDataTypes.Default,
    };

    fpcolumns['BA1ShowAsSeparateItemOnBill'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++fpcolumnIX,
        fieldName: 'BA1ShowAsSeparateItemOnBill',
        hidden: false,
        name: 'BA1 Show As Separate Item On Bill',
        dataType: EColumnExtractDataTypes.Default,
    };

    fpcolumns['BA1BCBSSCOtherSplit'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++fpcolumnIX,
        fieldName: 'BA1BCBSSCOtherSplit',
        hidden: false,
        name: 'BA1 BCBSSC/Other Split',
        dataType: EColumnExtractDataTypes.Default,
    };

    fpcolumns['BA1Comment'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++fpcolumnIX,
        fieldName: 'BA1Comment',
        hidden: false,
        name: 'BA1 Comment',
        dataType: EColumnExtractDataTypes.Default,
    };

    fpcolumns['RA1FeeType'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++fpcolumnIX,
        fieldName: 'RA1FeeType',
        hidden: false,
        name: 'RA1 Fee Type',
        dataType: EColumnExtractDataTypes.Default,
    };

    fpcolumns['RA1OtherFeeType'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++fpcolumnIX,
        fieldName: 'RA1OtherFeeType',
        hidden: false,
        name: 'RA1 Other Fee Type',
        dataType: EColumnExtractDataTypes.Default,
    };

    fpcolumns['RA1FeeAmount'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++fpcolumnIX,
        fieldName: 'RA1FeeAmount',
        hidden: false,
        name: 'RA1 Fee Amount',
        dataType: EColumnExtractDataTypes.Default,
    };

    fpcolumns['RA1BillGroup'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++fpcolumnIX,
        fieldName: 'RA1BillGroup',
        hidden: false,
        name: 'RA1 Bill Group',
        dataType: EColumnExtractDataTypes.Default,
    };

    fpcolumns['RA1ShowAsSeparateItemOnBill'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++fpcolumnIX,
        fieldName: 'RA1ShowAsSeparateItemOnBill',
        hidden: false,
        name: 'RA1 Show As Separate Item On Bill',
        dataType: EColumnExtractDataTypes.Default,
    };

    fpcolumns['RA1BCBSSCOtherSplit'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++fpcolumnIX,
        fieldName: 'RA1BCBSSCOtherSplit',
        hidden: false,
        name: 'RA1 BCBSSC/Other Split',
        dataType: EColumnExtractDataTypes.Default,
    };

    fpcolumns['RA1Comment'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++fpcolumnIX,
        fieldName: 'RA1Comment',
        hidden: false,
        name: 'RA1 Comment',
        dataType: EColumnExtractDataTypes.Default,
    };

    //fpcolumns['FeeComments'] = {
    //attributeId: '',
    //order: 0,
    //width: 15,
    //index: ++fpcolumnIX,
    //fieldName: 'FeeComments',
    //hidden: false,
    //name: 'Fee Comments',
    //dataType: EColumnExtractDataTypes.Default,
    //};

    stoplosscolumns['SLName'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++stoplosscolumnIX,
        fieldName: 'SLName',
        hidden: false,
        name: 'Stop Loss Name',
        dataType: EColumnExtractDataTypes.Default,
    };

    stoplosscolumns['SLprefixbase'] = {
        attributeId: '',
        order: 0,
        width: 18,
        index: ++stoplosscolumnIX,
        fieldName: 'SLprefixbase',
        hidden: false,
        name: 'SL - Prefix-Base',
        dataType: EColumnExtractDataTypes.Default,
    };

    stoplosscolumns['SLsuffixes'] = {
        attributeId: '',
        order: 0,
        width: 38,
        index: ++stoplosscolumnIX,
        fieldName: 'SLsuffixes',
        hidden: false,
        name: 'SL - Suffix(es)',
        dataType: EColumnExtractDataTypes.Default,
    };

    stoplosscolumns['SLBeginning'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++stoplosscolumnIX,
        fieldName: 'SLBeginning',
        hidden: false,
        name: 'Beginning',
        dataType: EColumnExtractDataTypes.Default,
    };

    stoplosscolumns['SLEnding'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++stoplosscolumnIX,
        fieldName: 'SLEnding',
        hidden: false,
        name: 'Ending',
        dataType: EColumnExtractDataTypes.Default,
    };

    stoplosscolumns['SLReleaseCredits'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++stoplosscolumnIX,
        fieldName: 'SLReleaseCredits',
        hidden: false,
        name: 'Release Credits',
        dataType: EColumnExtractDataTypes.Default,
    };

    stoplosscolumns['SLReinsurer'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++stoplosscolumnIX,
        fieldName: 'SLReinsurer',
        hidden: false,
        name: 'Reinsurer',
        dataType: EColumnExtractDataTypes.Default,
    };

    stoplosscolumns['SLOtherReinsurer'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++stoplosscolumnIX,
        fieldName: 'SLOtherReinsurer',
        hidden: false,
        name: 'Other Reinsurer',
        dataType: EColumnExtractDataTypes.Default,
    };

    stoplosscolumns['SLEnrollAggSpecific'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++stoplosscolumnIX,
        fieldName: 'SLEnrollAggSpecific',
        hidden: false,
        name: 'Enroll - Agg Specific',
        dataType: EColumnExtractDataTypes.Default,
    };

    stoplosscolumns['SLAdditionalLiability'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++stoplosscolumnIX,
        fieldName: 'SLAdditionalLiability',
        hidden: false,
        name: 'Additional Liability',
        dataType: EColumnExtractDataTypes.Default,
    };

    stoplosscolumns['SLSpecificDeductibleAmount'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++stoplosscolumnIX,
        fieldName: 'SLSpecificDeductibleAmount',
        hidden: false,
        name: 'Specific Deductible Amount',
        dataType: EColumnExtractDataTypes.Default,
    };

    stoplosscolumns['SLSpecificContractBasis'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++stoplosscolumnIX,
        fieldName: 'SLSpecificContractBasis',
        hidden: false,
        name: 'Specific Contract Basis',
        dataType: EColumnExtractDataTypes.Default,
    };

    stoplosscolumns['SLSpecificIncludeAccessFee'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++stoplosscolumnIX,
        fieldName: 'SLSpecificIncludeAccessFee',
        hidden: false,
        name: 'Specific Include Access Fee',
        dataType: EColumnExtractDataTypes.Default,
    };

    stoplosscolumns['SLSpecificOtherEnterOther'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++stoplosscolumnIX,
        fieldName: 'SLSpecificOtherEnterOther',
        hidden: false,
        name: 'Specific - Other (Enter Other)',
        dataType: EColumnExtractDataTypes.Default,
    };

    stoplosscolumns['SLSpecificMedical'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++stoplosscolumnIX,
        fieldName: 'SLSpecificMedical',
        hidden: false,
        name: 'Specific Medical',
        dataType: EColumnExtractDataTypes.Default,
    };

    stoplosscolumns['SLSpecificDrug'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++stoplosscolumnIX,
        fieldName: 'SLSpecificDrug',
        hidden: false,
        name: 'Specific Drug',
        dataType: EColumnExtractDataTypes.Default,
    };

    stoplosscolumns['SLSpecificVision'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++stoplosscolumnIX,
        fieldName: 'SLSpecificVision',
        hidden: false,
        name: 'Specific Vision',
        dataType: EColumnExtractDataTypes.Default,
    };

    stoplosscolumns['SLSpecificCarveOutDrug'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++stoplosscolumnIX,
        fieldName: 'SLSpecificCarveOutDrug',
        hidden: false,
        name: 'Carve Out Drug',
        dataType: EColumnExtractDataTypes.Default,
    };

    stoplosscolumns['SLSpecificDrugsOnCarveOutTable'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++stoplosscolumnIX,
        fieldName: 'SLSpecificDrugsOnCarveOutTable',
        hidden: false,
        name: 'Drugs on Carve-out Table',
        dataType: EColumnExtractDataTypes.Default,
    };

    stoplosscolumns['SLSpecificPBMVendor'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++stoplosscolumnIX,
        fieldName: 'SLSpecificPBMVendor',
        hidden: false,
        name: 'PBM Vendor',
        dataType: EColumnExtractDataTypes.Default,
    };

    datapacketcolumns['SLStopLossPacketsSLName'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++datapacketcolumnIX,
        fieldName: 'SLStopLossPacketsSLName',
        hidden: false,
        name: 'SL Packets - Stop Loss Name',
        dataType: EColumnExtractDataTypes.Default,
    };

    datapacketcolumns['SLStopLossPacketsName'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++datapacketcolumnIX,
        fieldName: 'SLStopLossPacketsName',
        hidden: false,
        name: 'Stop Loss Packets - Name',
        dataType: EColumnExtractDataTypes.Default,
    };

    datapacketcolumns['SLStopLossPacketsCompany'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++datapacketcolumnIX,
        fieldName: 'SLStopLossPacketsCompany',
        hidden: false,
        name: 'Stop Loss Packets - Company',
        dataType: EColumnExtractDataTypes.Default,
    };

    datapacketcolumns['SLStopLossPacketsEmailAddress'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++datapacketcolumnIX,
        fieldName: 'SLStopLossPacketsEmailAddress',
        hidden: false,
        name: 'Stop Loss Packets - Email Address',
        dataType: EColumnExtractDataTypes.Default,
    };

    stoplosscolumns['SLAggregateEnroll'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++stoplosscolumnIX,
        fieldName: 'SLAggregateEnroll',
        hidden: false,
        name: 'Aggregate - Enroll',
        dataType: EColumnExtractDataTypes.Default,
    };

    stoplosscolumns['SLAggregateContractBasis'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++stoplosscolumnIX,
        fieldName: 'SLAggregateContractBasis',
        hidden: false,
        name: 'Aggregate - Contract Basis',
        dataType: EColumnExtractDataTypes.Default,
    };

    stoplosscolumns['SLAggregateEnterOther'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++stoplosscolumnIX,
        fieldName: 'SLAggregateEnterOther',
        hidden: false,
        name: 'Aggregate - Enter Other',
        dataType: EColumnExtractDataTypes.Default,
    };

    stoplosscolumns['SLAggregateMedical'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++stoplosscolumnIX,
        fieldName: 'SLAggregateMedical',
        hidden: false,
        name: 'Aggregate Medical',
        dataType: EColumnExtractDataTypes.Default,
    };

    stoplosscolumns['SLAggregateDental'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++stoplosscolumnIX,
        fieldName: 'SLAggregateDental',
        hidden: false,
        name: 'Aggregate Dental',
        dataType: EColumnExtractDataTypes.Default,
    };

    stoplosscolumns['SLAggregateDrug'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++stoplosscolumnIX,
        fieldName: 'SLAggregateDrug',
        hidden: false,
        name: 'Aggregate Drug',
        dataType: EColumnExtractDataTypes.Default,
    };

    stoplosscolumns['SLAggregateVision'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++stoplosscolumnIX,
        fieldName: 'SLAggregateVision',
        hidden: false,
        name: 'Aggregate Vision',
        dataType: EColumnExtractDataTypes.Default,
    };

    stoplosscolumns['SLMinimumAnnualAttachmentPoint'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++stoplosscolumnIX,
        fieldName: 'SLMinimumAnnualAttachmentPoint',
        hidden: false,
        name: 'Minimum Annual Attachment Point',
        dataType: EColumnExtractDataTypes.Default,
    };

    stoplosscolumns['SLAttachmentPoint'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++stoplosscolumnIX,
        fieldName: 'SLAttachmentPoint',
        hidden: false,
        name: 'Attachment Point',
        dataType: EColumnExtractDataTypes.Default,
    };

    stoplosscolumns['SLSingleMedical'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++stoplosscolumnIX,
        fieldName: 'SLSingleMedical',
        hidden: false,
        name: 'Single - Medical',
        dataType: EColumnExtractDataTypes.Default,
    };

    stoplosscolumns['SLFamilyMedical'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++stoplosscolumnIX,
        fieldName: 'SLFamilyMedical',
        hidden: false,
        name: 'Family - Medical',
        dataType: EColumnExtractDataTypes.Default,
    };

    stoplosscolumns['SLEECHMedical'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++stoplosscolumnIX,
        fieldName: 'SLEECHMedical',
        hidden: false,
        name: 'EE/CH - Medical',
        dataType: EColumnExtractDataTypes.Default,
    };

    stoplosscolumns['SLEESPMedical'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++stoplosscolumnIX,
        fieldName: 'SLEESPMedical',
        hidden: false,
        name: 'EE/SP - Medical',
        dataType: EColumnExtractDataTypes.Default,
    };

    stoplosscolumns['SLTPMedical'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++stoplosscolumnIX,
        fieldName: 'SLTPMedical',
        hidden: false,
        name: 'TP - Medical',
        dataType: EColumnExtractDataTypes.Default,
    };

    stoplosscolumns['SLSingleDrug'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++stoplosscolumnIX,
        fieldName: 'SLSingleDrug',
        hidden: false,
        name: 'Single - Drug',
        dataType: EColumnExtractDataTypes.Default,
    };

    stoplosscolumns['SLFamilyDrug'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++stoplosscolumnIX,
        fieldName: 'SLFamilyDrug',
        hidden: false,
        name: 'Family - Drug',
        dataType: EColumnExtractDataTypes.Default,
    };

    stoplosscolumns['SLEECHDrug'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++stoplosscolumnIX,
        fieldName: 'SLEECHDrug',
        hidden: false,
        name: 'EE/CH - Drug',
        dataType: EColumnExtractDataTypes.Default,
    };

    stoplosscolumns['SLEESPDrug'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++stoplosscolumnIX,
        fieldName: 'SLEESPDrug',
        hidden: false,
        name: 'EE/SP - Drug',
        dataType: EColumnExtractDataTypes.Default,
    };

    stoplosscolumns['SLSingleDental'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++stoplosscolumnIX,
        fieldName: 'SLSingleDental',
        hidden: false,
        name: 'Single - Dental',
        dataType: EColumnExtractDataTypes.Default,
    };

    stoplosscolumns['SLFamilyDental'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++stoplosscolumnIX,
        fieldName: 'SLFamilyDental',
        hidden: false,
        name: 'Family - Dental',
        dataType: EColumnExtractDataTypes.Default,
    };

    stoplosscolumns['SLEECHDental'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++stoplosscolumnIX,
        fieldName: 'SLEECHDental',
        hidden: false,
        name: 'EE/CH - Dental',
        dataType: EColumnExtractDataTypes.Default,
    };

    stoplosscolumns['SLEESPDental'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++stoplosscolumnIX,
        fieldName: 'SLEESPDental',
        hidden: false,
        name: 'EE/SP - Dental',
        dataType: EColumnExtractDataTypes.Default,
    };

    stoplosscolumns['SLSingleVision'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++stoplosscolumnIX,
        fieldName: 'SLSingleVision',
        hidden: false,
        name: 'Single - Vision',
        dataType: EColumnExtractDataTypes.Default,
    };

    stoplosscolumns['SLFamilyVision'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++stoplosscolumnIX,
        fieldName: 'SLFamilyVision',
        hidden: false,
        name: 'Family - Vision',
        dataType: EColumnExtractDataTypes.Default,
    };

    stoplosscolumns['SLEECHVision'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++stoplosscolumnIX,
        fieldName: 'SLEECHVision',
        hidden: false,
        name: 'EE/CH - Vision',
        dataType: EColumnExtractDataTypes.Default,
    };

    stoplosscolumns['SLEESPVision'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++stoplosscolumnIX,
        fieldName: 'SLEESPVision',
        hidden: false,
        name: 'EE/SP - Vision',
        dataType: EColumnExtractDataTypes.Default,
    };

    laseredcolumns['SLLaserSLName'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++laseredcolumnIX,
        fieldName: 'SLLaserSLName',
        hidden: false,
        name: 'Laser - Stop Loss Name',
        dataType: EColumnExtractDataTypes.Default,
    };

    laseredcolumns['SLLaserClaimantType'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++laseredcolumnIX,
        fieldName: 'SLLaserClaimantType',
        hidden: false,
        name: 'Claimant Type',
        dataType: EColumnExtractDataTypes.Default,
    };

    laseredcolumns['SLLaserClaimantFirstName'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++laseredcolumnIX,
        fieldName: 'SLLaserClaimantFirstName',
        hidden: false,
        name: 'Laser Claimant First Name',
        dataType: EColumnExtractDataTypes.Default,
    };

    laseredcolumns['SLLaserClaimantLastName'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++laseredcolumnIX,
        fieldName: 'SLLaserClaimantLastName',
        hidden: false,
        name: 'Laser Claimant Last Name',
        dataType: EColumnExtractDataTypes.Default,
    };

    laseredcolumns['SLLaserSubscriberSSNAltID'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++laseredcolumnIX,
        fieldName: 'SLLaserSubscriberSSNAltID',
        hidden: false,
        name: 'Laser - Subscriber SSN/Alt ID',
        dataType: EColumnExtractDataTypes.Default,
    };

    laseredcolumns['SLLaserPatientDOB'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++laseredcolumnIX,
        fieldName: 'SLLaserPatientDOB',
        hidden: false,
        name: 'Laser - Patient Date of Birth',
        dataType: EColumnExtractDataTypes.Default,
    };

    laseredcolumns['SLLaserSpecificDeductibleAmount'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++laseredcolumnIX,
        fieldName: 'SLLaserSpecificDeductibleAmount',
        hidden: false,
        name: 'Laser - Specific Deductible Amount',
        dataType: EColumnExtractDataTypes.Default,
    };

    laseredcolumns['SLLaserContractBasis'] = {
        attributeId: '',
        order: 0,
        width: 15,
        index: ++laseredcolumnIX,
        fieldName: 'SLLaserContractBasis',
        hidden: false,
        name: 'Laser - Contract Basis (if applicable)',
        dataType: EColumnExtractDataTypes.Default,
    };

    const data = state.data.json;
    const snapshotFields = data.fields;

    // Contacts: Prepare the data
    // each claims AR
    // id -> contact record

    const contactLookup: Record<string, FAM_IEntityReferenceValue> = {};

    data.claimsARs.forEach(eachClaimsAR => {

        const billingContactAttSets = eachClaimsAR.attributeSets.filter(t => t.attributeSetRef.id === $matt_$accounts_receivable_$bcbs_attributeset_claimsarcontact_id)
        // Billing Contact

        billingContactAttSets.forEach(eachAttSet => {

            const fields = ArrayToLookupByPredicate(eachAttSet.fields, t => t.configRef.id);
            const contact = fields[$att_$accounts_receivable_$bcbs_contact_id];
            if (contact.values?.[0]?.value?.type === 'entity') {
                const entity = contact.values?.[0]?.value;
                contactLookup[entity.id] = { ...entity };
            }
        })

    });

    const recordTest: Record<string, string> = {};


    const contactLookupResult = await dataSource.contacts_byIds_getAsync(Object.keys(contactLookup));
    //for (const key in contactLookupResult) {
    //    recordTest[key] = contactLookupResult[key].emailaddress1;
    //}
    //if (contactLookupResult !== undefined) {
    //    contactLookupResultFinal = contactLookupResult;
    //}



    //feesAndPremiums
    //stopLoss
    //plans
    //groupStructure
    let row: Record<string, string> = {};
    const account = state.status.account! as IAccountExtended;


    const groupConfigurationFields = ArrayToLookupByPredicateWithMap(data.fields, t => t.configRef.id, t => {
        const attribute = state.data.config.cache.map_bcbs_config_attribute[t.configRef.id];
        const masterAttribute = state.data.config.cache.map_bcbs_config_masterattribute[attribute._bcbs_config_masterattributeid_value!];
        const controlType = masterAttribute.bcbs_attributetypecode as EControlType;
        return {
            field: t,
            attribute,
            masterAttribute,
            controlType,
        }
    });

    // Legal Group Name
    // TODO Link to attribute
    const LegalGroupNumber = groupConfigurationFields[$att_$group_configuration_$bcbs_legalgroupname_id];

    //const plansLookup = ArrayToLookupByPredicate(data.plans, t=>t.id);
    //plansLookup['1234-456'].fields

    row.groupName = friendlyValue(LegalGroupNumber.controlType, LegalGroupNumber.field.values[0].value);
    row.groupName = account.name!;

    //let gcEffDateInit = new Date(data.effectiveDate!.value);
    //gcEffDateInit.setHours(gcEffDateInit.getHours() + 8);
    //let gcEffDateFinal = gcEffDateInit.getMonth() + 1 + '/' + gcEffDateInit.getDate() + '/' + gcEffDateInit.getFullYear()
    row.effectiveDate = formatDate(parseDate(data.effectiveDate!.value, 'local:yyyy-MM-dd'), 'en-US-ET');

    const benefitYearStart = groupConfigurationFields[$att_$group_configuration_$bcbs_fin_financialrecordsforbenefityear_e95ff1471414ed11b83d000d3a58ea31_id];
    const contractEndDate = groupConfigurationFields[$att_$group_configuration_$bcbs_contract_end_date_id];
    const advancedDeposits = groupConfigurationFields[$att_$group_configuration_$bcbs_fin_payments_adv_deposits_id];
    const gcEnterAmount = groupConfigurationFields[$att_$group_configuration_$bcbs_fin_payments_adv_deposits_yes_amt_id];
    const stopLossPending = groupConfigurationFields[$att_$group_configuration_$bcbs_stoplosspending_id];
    const gcNotes = groupConfigurationFields[$att_$group_configuration_$bcbs_fin_implementationnotesandcomments_0979c03f14e8ec11bb3c000d3a5a370f_id];
    const gcNumberOfClaimsARs = groupConfigurationFields[$att_$group_configuration_$bcbs_finnumberofarclaimsrecordsrequired_id];
    //const gcCancellationEffectiveDate = groupConfigurationFields['0979c03f-14e8-ec11-bb3c-000d3a5a370f'];
    const gcPayRunOutClaims = groupConfigurationFields[$att_$group_configuration_$bcbs_payrunoutclaims_id];
    const gcPayRunOutClaimsHowManyMonths = groupConfigurationFields[$att_$group_configuration_$bcbs_payrunoutclaimshowmanymonths_id];
    const gcRunOutClaimsEndDates = groupConfigurationFields[$att_$group_configuration_$bcbs_runoutclaimsenddate_id];
    const gcRunOutTermsVerification = groupConfigurationFields[$att_$group_configuration_$bcbs_runoutverification_id];
    let stopLossPendingValue = "No";
    if (benefitYearStart.field.values[0].value !== null)
        row.benefitYearStart = formatDate(parseDate(friendlyValue(benefitYearStart.controlType, benefitYearStart.field.values[0].value), 'local:yyyy-MM-dd'), 'en-US-ET');
    if (contractEndDate.field.values[0].value !== null)
        row.contractEndDate = formatDate(parseDate(friendlyValue(contractEndDate.controlType, contractEndDate.field.values[0].value), 'local:yyyy-MM-dd'), 'en-US-ET');
    row.recordStatus = data.status.name;
    if (advancedDeposits.field.values[0].value !== null)
        row.advancedDeposits = friendlyValue(advancedDeposits.controlType, advancedDeposits.field.values[0].value);
    if (gcEnterAmount.field.values[0].value !== null)
        row.enterAmount = friendlyValue(gcEnterAmount.controlType, gcEnterAmount.field.values[0].value);
    if (stopLossPending.field.values[0].value !== null) {
        row.stopLossPending = friendlyValue(stopLossPending.controlType, stopLossPending.field.values[0].value);
        stopLossPendingValue = friendlyValue(stopLossPending.controlType, stopLossPending.field.values[0].value);
    }
    if (gcNotes.field.values[0].value !== null)
        row.gcNotes = friendlyValue(gcNotes.controlType, gcNotes.field.values[0].value);
    if (gcNumberOfClaimsARs.field.values[0].value !== null)
        row.numberofClaimsARRecordsRequired = friendlyValue(gcNumberOfClaimsARs.controlType, gcNumberOfClaimsARs.field.values[0].value);

    if (gcPayRunOutClaims.field.values[0].value !== null)
        row.payRunOutClaims = friendlyValue(gcPayRunOutClaims.controlType, gcPayRunOutClaims.field.values[0].value);
    if (gcPayRunOutClaimsHowManyMonths.field.values[0].value !== null)
        row.payRunOutClaimsHowManyMonths = friendlyValue(gcPayRunOutClaimsHowManyMonths.controlType, gcPayRunOutClaimsHowManyMonths.field.values[0].value);
    if (gcRunOutClaimsEndDates.field.values[0].value !== null)
        row.runOutClaimsEndDate = friendlyValue(gcRunOutClaimsEndDates.controlType, gcRunOutClaimsEndDates.field.values[0].value);
    if (gcRunOutTermsVerification.field.values[0].value !== null)
        row.runOutTermsVerification = friendlyValue(gcRunOutTermsVerification.controlType, gcRunOutTermsVerification.field.values[0].value);
    /*GC
    Effective Date - should be able to pull right from Snapshot
    Financial Records for Benefit Year Starting
    Contract End Date
    Record Status
    Advanced Deposits
    Enter Amount
    Stop Loss Pending?
    Notes and Comments
    Number of AR Claims records required:
    Cancellation Effective Date
    Pay Run Out Claims
    Pay Run Out Claims How Many Months
    Run Out Claims End Date
    Run Out Terms Verification
    */

    //Group Structure
    //let groupNumbers: string[] = [];
    //data.groupStructure?.groupNumbers?.forEach(q => {
    //    if (q.groupNumber) {
    //        const groupNumber = q.groupNumber;
    //        if (q.deactivated === false)
    //            groupNumbers.push(groupNumber);
    //    }
    //});
    //const groupNumbersSort = groupNumbers.sort();
    //const prefixBases: string[] = [];
    //if (groupNumbersSort.length > 0) {
    //    let prefixbaseNumber = groupNumbers[0].substring(0, 8);
    //    prefixBases.push(prefixbaseNumber);
    //    groupNumbersSort.forEach(function (item, index) {
    //        if (item.substring(0, 8) !== prefixbaseNumber) {
    //            prefixbaseNumber = item.substring(0, 8);
    //            prefixBases.push(prefixbaseNumber);
    //        }
    //    });

    //}

    //if (prefixBases.length === 1) {
    //    //row.prefixbase = prefixBases[0];
    //    let suffixes = "";
    //    groupNumbersSort.forEach(function (item, index) {
    //        if (index === groupNumbersSort.length - 1)
    //            suffixes += groupNumbersSort[index].substring(9, 11);
    //        else
    //            suffixes += groupNumbersSort[index].substring(9, 11) + ", ";
    //    });
    //    //suffixes.replace(", ")
    //    //row.suffixes = suffixes;

    //}

    //AR Section
    if (data.claimsARs.length > 0) {
        //row.ar = data.claimsARs[0].name;
        data.claimsARs.forEach(eachAR => {
            let claimsarrow: Record<string, string> = {};
            const ARFields = ArrayToLookupByPredicateWithMap(eachAR.fields, t => t.configRef.id, t => {
                const attribute = state.data.config.cache.map_bcbs_config_attribute[t.configRef.id];

                if (!attribute)
                    return null as any;

                const masterAttribute = state.data.config.cache.map_bcbs_config_masterattribute[attribute._bcbs_config_masterattributeid_value!];
                const controlType = masterAttribute.bcbs_attributetypecode as EControlType;
                return {
                    field: t,
                    attribute,
                    masterAttribute,
                    controlType,
                }
            });
            //Group Structure
            let groupNumbers: string[] = [];
            data.groupStructure?.groupNumbers?.forEach(q => {
                if (q.accountsReceivableRef?.id === eachAR.id) {
                    if (q.groupNumber) {
                        const groupNumber = q.groupNumber;
                        if (q.deactivated === false)
                            groupNumbers.push(groupNumber);
                    }
                }
            });
            const groupNumbersSort = groupNumbers.sort();
            const prefixBases: string[] = [];
            if (groupNumbersSort.length > 0) {
                let prefixbaseNumber = groupNumbers[0].substring(0, 8);
                prefixBases.push(prefixbaseNumber);
                groupNumbersSort.forEach(function (item, index) {
                    if (item.substring(0, 8) !== prefixbaseNumber) {
                        prefixbaseNumber = item.substring(0, 8);
                        prefixBases.push(prefixbaseNumber);
                    }
                });

            }
            const prefixBases99: string[] = [];
            if (groupNumbersSort.length > 0) {
                let prefixbaseNumber = groupNumbers[0].substring(0, 8);
                groupNumbersSort.forEach(function (item, index) {
                    if (groupNumbersSort[index].substring(9, 11) === "99") {
                        prefixbaseNumber = item.substring(0, 8);
                        prefixBases99.push(prefixbaseNumber);
                    }
                });

            }

            if (prefixBases.length === 1) {
                claimsarrow.ARprefixbase = prefixBases[0];
                let suffixes = "";
                groupNumbersSort.forEach(function (item, index) {
                    if (index === groupNumbersSort.length - 1)
                        suffixes += groupNumbersSort[index].substring(9, 11);
                    else
                        suffixes += groupNumbersSort[index].substring(9, 11) + ", ";
                });
                //suffixes.replace(", ")
                claimsarrow.ARsuffixes = suffixes;

            }
            else if (prefixBases.length > 1) {
                let arprefixBaseNumbers = "";
                let suffixes = "";
                prefixBases.forEach(function (item, index) {
                    if (index === prefixBases.length - 1)
                        arprefixBaseNumbers += item;
                    else
                        arprefixBaseNumbers += item + ",";
                    groupNumbersSort.forEach(function (suffixitem, suffixindex) {
                        if (suffixitem.substring(0, 8) === item) {
                            if (suffixindex === groupNumbersSort.length - 1)
                                suffixes += suffixitem;
                            else
                                suffixes += suffixitem + ", ";
                        }
                    });
                });
                claimsarrow.ARprefixbase = arprefixBaseNumbers;
                claimsarrow.ARsuffixes = suffixes;

            }
            const ARmethodofpaymentclaims = ARFields[$att_$accounts_receivable_$bcbs_fin_payments_method_claims_id];
            const ARbankdraft = ARFields[$att_$accounts_receivable_$bcbs_fin_payments_method_claims_bank_id];
            const ARwiretransferach = ARFields[$att_$accounts_receivable_$bcbs_fin_payments_method_claims_wire_id];
            const ARPAI = ARFields[$att_$accounts_receivable_$bcbs_pai_claimspayment_id];
            const ARClaimsBillingFrequency = ARFields[$att_$accounts_receivable_$bcbs_claimsbillingfrequency_id];
            const ARinterestChargesOnLatePayments = ARFields[$att_$accounts_receivable_$bcbs_fin_int_chrgs_late_pay_per_id];
            const ARprintAccessFeeDataOnWeeklyClaimsDetail = ARFields[$att_$accounts_receivable_$bcbs_claims_arpassprintaccessfeedataonweekly_id];
            const ARterminationfeeaspercentageofclaim = ARFields[$att_$accounts_receivable_$bcbs_fin_term_fee_designation_id];
            const ARterminationfeeswillbepaidaspercentofclaim = ARFields[$att_$accounts_receivable_$bcbs_fin_term_fee_mg_per_of_claim_id];
            const ARAdminMonthsBilled = ARFields[$att_$accounts_receivable_$bcbs_fin_term_fee_admin_months_billed_id];
            const ARTotalAdminFeeAmount = ARFields[$att_$accounts_receivable_$bcbs_fin_term_fee_total_admin_id];
            const ARSCLocalAdminAmount = ARFields[$att_$accounts_receivable_$bcbs_fin_term_fee_sc_id];
            const ARPartnerPlanAmount = ARFields[$att_$accounts_receivable_$bcbs_fin_term_fee_partner_plan_id];
            const ARBillTerminationFeesTo = ARFields[$att_$accounts_receivable_$bcbs_fin_term_bill_to_id];
            const ARTerminationFeeComments = ARFields[$att_$accounts_receivable_$bcbs_fin_term_fee_comments_id];
            const ARBlueCardNationalAdminFeesPassthroughto = ARFields[$att_$accounts_receivable_$bcbs_fin_fees_blue_nat_admin_fees_fl_id];
            const ARTravelersOOAAdminFeesPassthroughto = ARFields[$att_$accounts_receivable_$bcbs_fin_fees_travel_ooa_admin_pass_group_fl_id];
            const ARCustomAdminPCPMreimbursedthroughCBF = ARFields[$att_$accounts_receivable_$bcbs_customadminpcpmreimbursedthroughcbf_id];
            const ARBlueCardNationalAccessFeesPassthroughto = ARFields[$att_$accounts_receivable_$bcbs_fin_fees_blue_nat_access_fees_fl_id];
            const ARTravelersOOAAccessFeesPassthroughto = ARFields[$att_$accounts_receivable_$bcbs_fin_fees_travel_ooa_access_pass_group_fl_id];
            const ARhealthOptions = ARFields[$att_$accounts_receivable_$bcbs_claims_ar_healthoptions_id];

            //const ARterminationFeesWillBePaid = ARFields['c2d36d78-b28d-ec11-b400-0022480a93ed'];
            //const ARComments = ARFields['c0d36d78-b28d-ec11-b400-0022480a93ed'];
            const mgInStateOtherAmount = ARFields[$att_$accounts_receivable_$bcbs_claims_armginstateotheramount_id];//Done
            const inStateSavings = ARFields[$att_$accounts_receivable_$bcbs_instatesavingsenter_id];//Done
            const inStateCappedAtNA = ARFields[$att_$accounts_receivable_$bcbs_claims_ar_sharedsavingscappedat_id];//Done
            const naInStateOtherAmount = ARFields[$att_$accounts_receivable_$bcbs_claims_ar_sharedsavingscapotheramount_id];//Done
            const inStatePercentageOfSavings = ARFields[$att_$accounts_receivable_$bcbs_claims_ar_percentofsavings_id];//Done
            const inStateCappedAtMG = ARFields[$att_$accounts_receivable_$bcbs_claims_ar_instatenationalcappedat_id];//Done
            const mgOutOfStateOtherAmount = ARFields[$att_$accounts_receivable_$bcbs_claims_armgoosotheramount_id];//Done
            const outOfStateSavings = ARFields[$att_$accounts_receivable_$bcbs_claims_ar_outofstatesavingsenter_id];//Done
            const outOfStateCappedAtNA = ARFields[$att_$accounts_receivable_$bcbs_claims_aroossharedsavingscappedat_id];//Done
            const naOutOfStateOtherAmount = ARFields[$att_$accounts_receivable_$bcbs_claims_ar_oossharedsavingsotheramount_id];//Done
            const outOfStatePercentageOfSavings = ARFields[$att_$accounts_receivable_$bcbs_claims_ar_oospercentofsavings_id];//Done
            const outOfStateCappedAtMG = ARFields[$att_$accounts_receivable_$bcbs_claims_aroutofstatenationalcappedat_id];//Done
            const ARprintsummaryonweeklyclaimsdetailMG = ARFields[$att_$accounts_receivable_$bcbs_printsummaryonweeklyclaimsdetail_id];//Done
            const ARprintsummaryonweeklyclaimsdetailNA = ARFields[$att_$accounts_receivable_$bcbs_claims_arprintsummaryonweeklyclaimsdetail_id];//Done
            const ceilingLimitReport = ARFields[$att_$accounts_receivable_$bcbs_fin_fin_report_ceiling_id];//Done
            const ceilingLimitReportIfYesEnterAmount = ARFields[$att_$accounts_receivable_$bcbs_fin_fin_report_ceiling_cost_id];//Done
            //const fiftyPercentOfSpecificStopLoss = ARFields['cbd36d78-b28d-ec11-b400-0022480a93ed'];//Done
            const oneHundredPercentOfSpecificStopLoss = ARFields[$att_$accounts_receivable_$bcbs_fin_fin_report_ceiling_100_pec_id];//Done
            const summaryReportPFAB400 = ARFields[$att_$accounts_receivable_$bcbs_fin_fin_report_summary_rpt_id];//Done
            const ARIPRPClaimsEditBillGroup = ARFields[$att_$accounts_receivable_$bcbs_iprpcebillgroup_ar_id];//Done
            const ARIPRPDisplayClaimsEditOnBill = ARFields[$att_$accounts_receivable_$bcbs_displayssceline_ar_id];//Done
            const ARIPRPClaimsEditCapAmount = ARFields[$att_$accounts_receivable_$bcbs_cecapamount_ar_id];//Done

            claimsarrow.ARClaimsARName = eachAR.name;
            if (ARmethodofpaymentclaims.field.values[0].value !== null)
                claimsarrow.ARmethodofpaymentclaims = friendlyValue(ARmethodofpaymentclaims.controlType, ARmethodofpaymentclaims.field.values[0].value);
            if (ARbankdraft.field.values[0].value !== null)
                claimsarrow.ARbankdraft = friendlyValue(ARbankdraft.controlType, ARbankdraft.field.values[0].value);
            if (ARwiretransferach.field.values[0].value !== null)
                claimsarrow.ARwiretransferACH = friendlyValue(ARwiretransferach.controlType, ARwiretransferach.field.values[0].value);
            if (ARPAI !== undefined) {
                if (ARPAI.field.values[0].value !== null)
                    claimsarrow.ARPAI = friendlyValue(ARPAI.controlType, ARPAI.field.values[0].value);
            }
            if (ARClaimsBillingFrequency !== undefined) {
                if (ARClaimsBillingFrequency.field.values[0].value !== null)
                    claimsarrow.ARClaimsBillingFrequency = friendlyValue(ARClaimsBillingFrequency.controlType, ARClaimsBillingFrequency.field.values[0].value);
            }
            if (ARinterestChargesOnLatePayments.field.values[0].value !== null)
                claimsarrow.interestChargesOnLatePayments = friendlyValue(ARinterestChargesOnLatePayments.controlType, ARinterestChargesOnLatePayments.field.values[0].value);

            if (ARterminationfeeaspercentageofclaim.field.values[0].value !== null)
                claimsarrow.ARterminationfeeaspercentageofclaim = friendlyValue(ARterminationfeeaspercentageofclaim.controlType, ARterminationfeeaspercentageofclaim.field.values[0].value);
            if (ARterminationfeeswillbepaidaspercentofclaim.field.values[0].value !== null)
                claimsarrow.ARterminationfeeswillbepaidaspercentofclaim = friendlyValue(ARterminationfeeswillbepaidaspercentofclaim.controlType, ARterminationfeeswillbepaidaspercentofclaim.field.values[0].value);
            if (ARAdminMonthsBilled.field.values[0].value !== null)
                claimsarrow.ARAdminMonthsBilled = friendlyValue(ARAdminMonthsBilled.controlType, ARAdminMonthsBilled.field.values[0].value);
            if (ARTotalAdminFeeAmount.field.values[0].value !== null)
                claimsarrow.ARTotalAdminFeeAmount = friendlyValue(ARTotalAdminFeeAmount.controlType, ARTotalAdminFeeAmount.field.values[0].value);
            if (ARSCLocalAdminAmount.field.values[0].value !== null)
                claimsarrow.ARSCLocalAdminAmount = friendlyValue(ARSCLocalAdminAmount.controlType, ARSCLocalAdminAmount.field.values[0].value);
            if (ARPartnerPlanAmount.field.values[0].value !== null)
                claimsarrow.ARPartnerPlanAmount = friendlyValue(ARPartnerPlanAmount.controlType, ARPartnerPlanAmount.field.values[0].value);
            if (ARBillTerminationFeesTo.field.values[0].value !== null)
                claimsarrow.ARBillTerminationFeesTo = friendlyValue(ARBillTerminationFeesTo.controlType, ARBillTerminationFeesTo.field.values[0].value);
            if (ARTerminationFeeComments.field.values[0].value !== null)
                claimsarrow.ARTerminationFeeComments = friendlyValue(ARTerminationFeeComments.controlType, ARTerminationFeeComments.field.values[0].value);
            if (ARBlueCardNationalAdminFeesPassthroughto.field.values[0].value !== null)
                claimsarrow.ARBlueCardNationalAdminFeesPassthroughto = friendlyValue(ARBlueCardNationalAdminFeesPassthroughto.controlType, ARBlueCardNationalAdminFeesPassthroughto.field.values[0].value);
            if (ARTravelersOOAAdminFeesPassthroughto.field.values[0].value !== null)
                claimsarrow.ARTravelersOOAAdminFeesPassthroughto = friendlyValue(ARTravelersOOAAdminFeesPassthroughto.controlType, ARTravelersOOAAdminFeesPassthroughto.field.values[0].value);
            if (ARCustomAdminPCPMreimbursedthroughCBF.field.values[0].value !== null)
                claimsarrow.ARCustomAdminPCPMreimbursedthroughCBF = friendlyValue(ARCustomAdminPCPMreimbursedthroughCBF.controlType, ARCustomAdminPCPMreimbursedthroughCBF.field.values[0].value);
            if (ARBlueCardNationalAccessFeesPassthroughto.field.values[0].value !== null)
                claimsarrow.ARBlueCardNationalAccessFeesPassthroughto = friendlyValue(ARBlueCardNationalAccessFeesPassthroughto.controlType, ARBlueCardNationalAccessFeesPassthroughto.field.values[0].value);
            if (ARTravelersOOAAccessFeesPassthroughto.field.values[0].value !== null)
                claimsarrow.ARTravelersOOAAccessFeesPassthroughto = friendlyValue(ARTravelersOOAAccessFeesPassthroughto.controlType, ARTravelersOOAAccessFeesPassthroughto.field.values[0].value);

            if (ARhealthOptions.field.values[0].value !== null)
                claimsarrow.healthOptions = friendlyValue(ARhealthOptions.controlType, ARhealthOptions.field.values[0].value);

            //if (ARterminationFeesWillBePaid.field.values[0].value !== null)
            //claimsarrow.terminationFeesWillBePaid = friendlyValue(ARterminationFeesWillBePaid.controlType, ARterminationFeesWillBePaid.field.values[0].value);
            //if (ARComments.field.values[0].value !== null)
            //claimsarrow.ARComments = friendlyValue(ARComments.controlType, ARComments.field.values[0].value);
            if (mgInStateOtherAmount.field.values[0].value !== null)
                claimsarrow.mgInStateOtherAmount = friendlyValue(mgInStateOtherAmount.controlType, mgInStateOtherAmount.field.values[0].value);
            if (inStateSavings.field.values[0].value !== null)
                claimsarrow.inStateSavings = friendlyValue(inStateSavings.controlType, inStateSavings.field.values[0].value);
            if (inStateCappedAtNA.field.values[0].value !== null)
                claimsarrow.inStateCappedAtNA = friendlyValue(inStateCappedAtNA.controlType, inStateCappedAtNA.field.values[0].value);
            if (naInStateOtherAmount.field.values[0].value !== null)
                claimsarrow.naInStateOtherAmount = friendlyValue(naInStateOtherAmount.controlType, naInStateOtherAmount.field.values[0].value);
            if (inStatePercentageOfSavings.field.values[0].value !== null)
                claimsarrow.inStatePercentageOfSavings = friendlyValue(inStatePercentageOfSavings.controlType, inStatePercentageOfSavings.field.values[0].value);
            if (inStateCappedAtMG.field.values[0].value !== null)
                claimsarrow.inStateCappedAtMG = friendlyValue(inStateCappedAtMG.controlType, inStateCappedAtMG.field.values[0].value);
            if (mgOutOfStateOtherAmount.field.values[0].value !== null)
                claimsarrow.mgOutOfStateOtherAmount = friendlyValue(mgOutOfStateOtherAmount.controlType, mgOutOfStateOtherAmount.field.values[0].value);
            if (outOfStateSavings.field.values[0].value !== null)
                claimsarrow.outOfStateSavings = friendlyValue(outOfStateSavings.controlType, outOfStateSavings.field.values[0].value);
            if (outOfStateCappedAtNA.field.values[0].value !== null)
                claimsarrow.outOfStateCappedAtNA = friendlyValue(outOfStateCappedAtNA.controlType, outOfStateCappedAtNA.field.values[0].value);
            if (naOutOfStateOtherAmount.field.values[0].value !== null)
                claimsarrow.naOutOfStateOtherAmount = friendlyValue(naOutOfStateOtherAmount.controlType, naOutOfStateOtherAmount.field.values[0].value);
            if (outOfStatePercentageOfSavings.field.values[0].value !== null)
                claimsarrow.outOfStatePercentageOfSavings = friendlyValue(outOfStatePercentageOfSavings.controlType, outOfStatePercentageOfSavings.field.values[0].value);
            if (outOfStateCappedAtMG.field.values[0].value !== null)
                claimsarrow.outOfStateCappedAtMG = friendlyValue(outOfStateCappedAtMG.controlType, outOfStateCappedAtMG.field.values[0].value);
            if (ARprintsummaryonweeklyclaimsdetailMG.field.values[0].value !== null)
                claimsarrow.ARprintsummaryonweeklyclaimsdetailMG = friendlyValue(ARprintsummaryonweeklyclaimsdetailMG.controlType, ARprintsummaryonweeklyclaimsdetailMG.field.values[0].value);
            if (ARprintsummaryonweeklyclaimsdetailNA.field.values[0].value !== null)
                claimsarrow.ARprintsummaryonweeklyclaimsdetailNA = friendlyValue(ARprintsummaryonweeklyclaimsdetailNA.controlType, ARprintsummaryonweeklyclaimsdetailNA.field.values[0].value);
            if (ARprintAccessFeeDataOnWeeklyClaimsDetail.field.values[0].value !== null)
                claimsarrow.printAccessFeeDataOnWeeklyClaimsDetail = friendlyValue(ARprintAccessFeeDataOnWeeklyClaimsDetail.controlType, ARprintAccessFeeDataOnWeeklyClaimsDetail.field.values[0].value);
            if (ceilingLimitReport.field.values[0].value !== null)
                claimsarrow.ceilingLimitReport = friendlyValue(ceilingLimitReport.controlType, ceilingLimitReport.field.values[0].value);
            if (ceilingLimitReportIfYesEnterAmount.field.values[0].value !== null)
                claimsarrow.ceilingLimitReportIfYesEnterAmount = friendlyValue(ceilingLimitReportIfYesEnterAmount.controlType, ceilingLimitReportIfYesEnterAmount.field.values[0].value);
            //if (fiftyPercentOfSpecificStopLoss.field.values[0].value !== null)
                //claimsarrow.fiftyPercentOfSpecificStopLoss = friendlyValue(fiftyPercentOfSpecificStopLoss.controlType, fiftyPercentOfSpecificStopLoss.field.values[0].value);
            if (oneHundredPercentOfSpecificStopLoss.field.values[0].value !== null)
                claimsarrow.oneHundredPercentOfSpecificStopLoss = friendlyValue(oneHundredPercentOfSpecificStopLoss.controlType, oneHundredPercentOfSpecificStopLoss.field.values[0].value);
            if (summaryReportPFAB400.field.values[0].value !== null)
                claimsarrow.summaryReportPFAB400 = friendlyValue(summaryReportPFAB400.controlType, summaryReportPFAB400.field.values[0].value);
            if (ARIPRPClaimsEditBillGroup !== undefined) {
                if (ARIPRPClaimsEditBillGroup.field.values[0].value !== null)
                    claimsarrow.ARIPRPClaimsEditBillGroup = friendlyValue(ARIPRPClaimsEditBillGroup.controlType, ARIPRPClaimsEditBillGroup.field.values[0].value);
            }
            if (ARIPRPDisplayClaimsEditOnBill !== undefined) {
                if (ARIPRPDisplayClaimsEditOnBill.field.values[0].value !== null)
                    claimsarrow.ARIPRPDisplayClaimsEditOnBill = friendlyValue(ARIPRPDisplayClaimsEditOnBill.controlType, ARIPRPDisplayClaimsEditOnBill.field.values[0].value);
            }
            if (ARIPRPClaimsEditCapAmount !== undefined) {
                if (ARIPRPClaimsEditCapAmount.field.values[0].value !== null)
                    claimsarrow.ARIPRPClaimsEditCapAmount = friendlyValue(ARIPRPClaimsEditCapAmount.controlType, ARIPRPClaimsEditCapAmount.field.values[0].value);
            }
            // Billing Contacts
            let arClaimsBillingContacts = eachAR.attributeSets.filter(q => q.attributeSetRef.id === $matt_$accounts_receivable_$bcbs_attributeset_claimsarcontact_id);
            if (arClaimsBillingContacts.length > 0) {
                arClaimsBillingContacts.forEach(eachContact => {
                    if (eachContact.deactivated === false) {
                        let contactrow: Record<string, string> = {};
                        let arClaimsBillingContactFields = ArrayToLookupByPredicateWithMap(eachContact.fields, t => t.configRef.id, t => {
                            const attribute = state.data.config.cache.map_bcbs_config_attribute[t.configRef.id];
                            const masterAttribute = state.data.config.cache.map_bcbs_config_masterattribute[attribute._bcbs_config_masterattributeid_value!];
                            const controlType = masterAttribute.bcbs_attributetypecode as EControlType;
                            return {
                                field: t,
                                attribute,
                                masterAttribute,
                                controlType,
                            }
                        });
                        const contact = arClaimsBillingContactFields[$att_$accounts_receivable_$bcbs_contact_id];
                        const claimsPHIContact = arClaimsBillingContactFields[$att_$accounts_receivable_$bcbs_claimsar_claimscontact_id];
                        const ceilingLimitContact = arClaimsBillingContactFields[$att_$accounts_receivable_$bcbs_claimsar_stoplosscontact_id];
                        const PFAB400ReportContact = arClaimsBillingContactFields[$att_$accounts_receivable_$bcbs_claimsar_pfabreportcontact_id];
                        const eBillInvoiceContact = arClaimsBillingContactFields[$att_$accounts_receivable_$bcbs_ebillinvoicecontactcode_id];
                        //arcontactgroupname
                        contactrow.arcontactgroupname = account.name!;
                        if (contact.field.values[0].value !== null)
                            contactrow.contactname = eachAR.name;
                        if (contact.field.values[0].value !== null) {
                            let contactid = (contact.field.values[0].value as FAM_IEntityReferenceValue).id;
                            //let finalcontact = contactLookupResult
                            contactrow.contact = friendlyValue(contact.controlType, contact.field.values[0].value);
                            if (contactLookupResult[contactid] !== undefined) {
                                contactrow.contactemailaddress = contactLookupResult[contactid].emailaddress1;

                            }
                        }
                        if (prefixBases99.length > 0) {
                            contactrow.arcontact99prefixbase = prefixBases99[0];
                        }
                        if (claimsPHIContact.field.values[0].value !== null)
                            contactrow.claimsPHIContact = friendlyValue(claimsPHIContact.controlType, claimsPHIContact.field.values[0].value);
                        if (ceilingLimitContact.field.values[0].value !== null)
                            contactrow.ceilingLimitContact = friendlyValue(ceilingLimitContact.controlType, ceilingLimitContact.field.values[0].value);
                        if (PFAB400ReportContact.field.values[0].value !== null)
                            contactrow.PFAB400ReportContact = friendlyValue(PFAB400ReportContact.controlType, PFAB400ReportContact.field.values[0].value);
                        if (eBillInvoiceContact.field.values[0].value !== null)
                            contactrow.eBillInvoiceContact = friendlyValue(eBillInvoiceContact.controlType, eBillInvoiceContact.field.values[0].value);
                        contactrows.push(contactrow);
                    }
                });

            }
            //Per Script Fees
            let perScriptFees = eachAR.attributeSets.filter(q => q.attributeSetRef.id === $matt_$accounts_receivable_$bcbs_attributeset_perscriptfee_id);
            if (perScriptFees.length > 0) {
                perScriptFees.forEach(eachFee => {
                    if (eachFee.deactivated === false) {
                        let feerow: Record<string, string> = {};
                        let perscriptFeeFields = ArrayToLookupByPredicateWithMap(eachFee.fields, t => t.configRef.id, t => {
                            const attribute = state.data.config.cache.map_bcbs_config_attribute[t.configRef.id];
                            const masterAttribute = state.data.config.cache.map_bcbs_config_masterattribute[attribute._bcbs_config_masterattributeid_value!];
                            const controlType = masterAttribute.bcbs_attributetypecode as EControlType;
                            return {
                                field: t,
                                attribute,
                                masterAttribute,
                                controlType,
                            }
                        });

                        const BCCAdmin = perscriptFeeFields[$att_$accounts_receivable_$bcbs_perscript_bccadminid_id];
                        const feeType = perscriptFeeFields[$att_$accounts_receivable_$bcbs_perscript_feetype_id];
                        const feeAmount = perscriptFeeFields[$att_$accounts_receivable_$bcbs_perscript_feeamount_id];
                        const Onsite = perscriptFeeFields[$att_$accounts_receivable_$bcbs_perscript_onsite_id];
                        const guaranteeStartDate = perscriptFeeFields[$att_$accounts_receivable_$bcbs_perscript_guaranteestartdate_id];
                        const guaranteeEndDate = perscriptFeeFields[$att_$accounts_receivable_$bcbs_perscript_guaranteeenddate_id];
                        feerow.PerScriptARName = eachAR.name;
                        if (BCCAdmin.field.values[0].value !== null)
                            feerow.PerScriptBCC = friendlyValue(BCCAdmin.controlType, BCCAdmin.field.values[0].value);
                        if (feeType.field.values[0].value !== null)
                            feerow.PerScriptFeeType = friendlyValue(feeType.controlType, feeType.field.values[0].value);
                        if (feeAmount.field.values[0].value !== null)
                            feerow.PerScriptFeeAmount = friendlyValue(feeAmount.controlType, feeAmount.field.values[0].value);
                        if (Onsite.field.values[0].value !== null)
                            feerow.PerScriptOnsite = friendlyValue(Onsite.controlType, Onsite.field.values[0].value);
                        if (guaranteeStartDate.field.values[0].value !== null)
                            feerow.PerScriptGuaranteeStartDate = formatDate(parseDate(friendlyValue(guaranteeStartDate.controlType, guaranteeStartDate.field.values[0].value), 'local:yyyy-MM-dd'), 'en-US-ET');
                        if (guaranteeEndDate.field.values[0].value !== null)
                            feerow.PerScriptGuaranteeEndDate = formatDate(parseDate(friendlyValue(guaranteeEndDate.controlType, guaranteeEndDate.field.values[0].value), 'local:yyyy-MM-dd'), 'en-US-ET');

                        perscriptrows.push(feerow);
                    }
                });

            }
            claimsarrows.push(claimsarrow);
        });
    }

    //Stop Loss Section
    //PBI 604803 - Only display Stop Loss if Stop Loss Pending is No
    if (data.stopLoss.length > 0 && stopLossPendingValue !== "Yes") {
        //row.stoploss = data.stopLoss[0].name;
        data.stopLoss.forEach(eachStopLoss => {
            let stoplossrow: Record<string, string> = {};
            const stopLossFields = ArrayToLookupByPredicateWithMap(eachStopLoss.fields, t => t.configRef.id, t => {
                const attribute = state.data.config.cache.map_bcbs_config_attribute[t.configRef.id];
                const masterAttribute = state.data.config.cache.map_bcbs_config_masterattribute[attribute._bcbs_config_masterattributeid_value!];
                const controlType = masterAttribute.bcbs_attributetypecode as EControlType;
                return {
                    field: t,
                    attribute,
                    masterAttribute,
                    controlType,
                }
            });

            //Group Structure
            let groupNumbers: string[] = [];
            data.groupStructure?.groupNumbers?.forEach(q => {
                if (q.stopLossRef?.id === eachStopLoss.id) {
                    if (q.groupNumber) {
                        const groupNumber = q.groupNumber;
                        if (q.deactivated === false)
                            groupNumbers.push(groupNumber);
                    }
                }
            });
            const groupNumbersSort = groupNumbers.sort();
            const prefixBases: string[] = [];
            if (groupNumbersSort.length > 0) {
                let prefixbaseNumber = groupNumbers[0].substring(0, 8);
                prefixBases.push(prefixbaseNumber);
                groupNumbersSort.forEach(function (item, index) {
                    if (item.substring(0, 8) !== prefixbaseNumber) {
                        prefixbaseNumber = item.substring(0, 8);
                        prefixBases.push(prefixbaseNumber);
                    }
                });

            }

            if (prefixBases.length === 1) {
                stoplossrow.SLprefixbase = prefixBases[0];
                let suffixes = "";
                groupNumbersSort.forEach(function (item, index) {
                    if (index === groupNumbersSort.length - 1)
                        suffixes += groupNumbersSort[index].substring(9, 11);
                    else
                        suffixes += groupNumbersSort[index].substring(9, 11) + ", ";
                });
                //suffixes.replace(", ")
                stoplossrow.SLsuffixes = suffixes;

            }
            else if (prefixBases.length > 1) {
                let slprefixBaseNumbers = "";
                let suffixes = "";
                prefixBases.forEach(function (item, index) {
                    if (index === prefixBases.length - 1)
                        slprefixBaseNumbers += item;
                    else
                        slprefixBaseNumbers += item + ",";
                    groupNumbersSort.forEach(function (suffixitem, suffixindex) {
                        if (suffixitem.substring(0, 8) === item) {
                            if (suffixindex === groupNumbersSort.length - 1)
                                suffixes += suffixitem;
                            else
                                suffixes += suffixitem + ", ";
                        }
                    });
                });
                stoplossrow.SLprefixbase = slprefixBaseNumbers;
                stoplossrow.SLsuffixes = suffixes;

            }

            const SLBeginning = stopLossFields[$att_$stop_loss_$bcbs_fin_stop_loss_begin_date_id];
            const SLEnding = stopLossFields[$att_$stop_loss_$bcbs_fin_stop_loss_end_date_id];
            const SLReleaseCredits = stopLossFields[$att_$stop_loss_$bcbs_releasecredits_id];
            const SLReinsurer = stopLossFields[$att_$stop_loss_$bcbs_adminfeesreinsurerid_id];
            const SLOtherReinsurer = stopLossFields[$att_$stop_loss_$bcbs_otherreinsurerid_id];
            const SLEnrollAggSpecific = stopLossFields[$att_$stop_loss_$bcbs_fin_agg_spec_ded_enroll_id];
            const SLAdditionalLiability = stopLossFields[$att_$stop_loss_$bcbs_fin_agg_spec_ded_add_liab_id];
            const SLSpecificDeductibleAmount = stopLossFields[$att_$stop_loss_$bcbs_fin_spec_stop_loss_ded_amt_id];
            const SLSpecificContractBasis = stopLossFields[$att_$stop_loss_$bcbs_fin_spec_stop_loss_contr_basis_id];
            const SLSpecificIncludeAccessFee = stopLossFields[$att_$stop_loss_$bcbs_fin_spec_stop_loss_access_fee_id];
            const SLSpecificOtherEnterOther = stopLossFields[$att_$stop_loss_$bcbs_fin_spec_stop_loss_contr_basis_other_id];
            const SLSpecificMedical = stopLossFields[$att_$stop_loss_$bcbs_fin_spec_stop_loss_cov_medical_id];
            const SLSpecificDrug = stopLossFields[$att_$stop_loss_$bcbs_fin_spec_stop_loss_cov_drug_id];
            const SLSpecificVision = stopLossFields[$att_$stop_loss_$bcbs_fin_spec_stop_loss_cov_vision_id];
            const SLSpecificCarveOutDrug = stopLossFields[$att_$stop_loss_$bcbs_fin_spec_stop_loss_carveout_drug_id];
            const SLSpecificDrugsOnCarveOutTable = stopLossFields[$att_$stop_loss_$bcbs_drugsoncarveouttablecode_id];
            const SLSpecificPBMVendor = stopLossFields[$att_$stop_loss_$bcbs_fin_spec_stop_loss_pbm_vendorid_id];
            //const SLStopLossPacketsName =
            //const SLStopLossPacketsCompany =
            //const SLStopLossPacketsEmailAddress =
            const SLAggregateEnroll = stopLossFields[$att_$stop_loss_$bcbs_fin_agg_stop_loss_enroll_id];
            const SLAggregateContractBasis = stopLossFields[$att_$stop_loss_$bcbs_fin_agg_stop_loss_contract_basis_id];
            const SLAggregateEnterOther = stopLossFields[$att_$stop_loss_$bcbs_fin_agg_stop_loss_contract_basis_other_id];
            const SLAggregateMedical = stopLossFields[$att_$stop_loss_$bcbs_fin_agg_stop_loss_cov_includes_med_id];
            const SLAggregateDental = stopLossFields[$att_$stop_loss_$bcbs_fin_spec_stop_loss_cov_dental_id];
            const SLAggregateDrug = stopLossFields[$att_$stop_loss_$bcbs_fin_agg_stop_loss_cov_includes_drug_id];
            const SLAggregateVision = stopLossFields[$att_$stop_loss_$bcbs_fin_agg_stop_loss_cov_includes_vision_id];
            const SLMinimumAnnualAttachmentPoint = stopLossFields[$att_$stop_loss_$bcbs_fin_att_points_mim_ann_att_point_id];
            const SLAttachmentPoint = stopLossFields[$att_$stop_loss_$bcbs_fin_att_points_att_point_id];
            const SLSingleMedical = stopLossFields[$att_$stop_loss_$bcbs_fin_att_points_ppo_single_id];
            const SLFamilyMedical = stopLossFields[$att_$stop_loss_$bcbs_fin_att_points_ppo_family_id];
            const SLEECHMedical = stopLossFields[$att_$stop_loss_$bcbs_fin_att_points_ppo_eech_id];
            const SLEESPMedical = stopLossFields[$att_$stop_loss_$bcbs_fin_att_points_ppo_eesp_id];
            const SLTPMedical = stopLossFields[$att_$stop_loss_$bcbs_fin_att_points_ppo_tp_id];
            const SLSingleDrug = stopLossFields[$att_$stop_loss_$bcbs_fin_att_points_drug_single_id];
            const SLFamilyDrug = stopLossFields[$att_$stop_loss_$bcbs_fin_att_points_drug_family_id];
            const SLEECHDrug = stopLossFields[$att_$stop_loss_$bcbs_fin_att_points_drug_eech_id];
            const SLEESPDrug = stopLossFields[$att_$stop_loss_$bcbs_fin_att_points_drug_eesp_id];
            const SLSingleDental = stopLossFields[$att_$stop_loss_$bcbs_fin_att_points_dental_single_id];
            const SLFamilyDental = stopLossFields[$att_$stop_loss_$bcbs_fin_att_points_dental_family_id];
            const SLEECHDental = stopLossFields[$att_$stop_loss_$bcbs_fin_att_points_dental_eech_id];
            const SLEESPDental = stopLossFields[$att_$stop_loss_$bcbs_fin_att_points_dental_eesp_id];
            const SLSingleVision = stopLossFields[$att_$stop_loss_$bcbs_fin_att_points_vision_single_id];
            const SLFamilyVision = stopLossFields[$att_$stop_loss_$bcbs_fin_att_points_vision_family_id];
            const SLEECHVision = stopLossFields[$att_$stop_loss_$bcbs_fin_att_points_vision_eech_id];
            const SLEESPVision = stopLossFields[$att_$stop_loss_$bcbs_fin_att_points_vision_eesp_id];
            //const SLLaserClaimantFirstName =
            //const SLLaserClaimantLastName =
            //const SLLaserSubscriberSSNAltID =
            //const SLLaserPatientDOB =
            //const SLLaserSpecificDeductibleAmount =
            //const SLLaserContractBasis =

            //const ARprintAccessFeeDataOnWeeklyClaimsDetail = ARFields['9ed36d78-b28d-ec11-b400-0022480a93ed'];
            stoplossrow.SLName = eachStopLoss.name;
            if (SLReinsurer.field.values[0].value !== null)
                stoplossrow.SLReinsurer = friendlyValue(SLReinsurer.controlType, SLReinsurer.field.values[0].value);
            if (SLOtherReinsurer.field.values[0].value !== null)
                stoplossrow.SLOtherReinsurer = friendlyValue(SLOtherReinsurer.controlType, SLOtherReinsurer.field.values[0].value);
            if (SLReleaseCredits.field.values[0].value !== null)
                stoplossrow.SLReleaseCredits = friendlyValue(SLReleaseCredits.controlType, SLReleaseCredits.field.values[0].value);
            if (SLBeginning.field.values[0].value !== null)
                stoplossrow.SLBeginning = formatDate(parseDate(friendlyValue(SLBeginning.controlType, SLBeginning.field.values[0].value), 'local:yyyy-MM-dd'), 'en-US-ET');
            if (SLEnding.field.values[0].value !== null)
                stoplossrow.SLEnding = formatDate(parseDate(friendlyValue(SLEnding.controlType, SLEnding.field.values[0].value), 'local:yyyy-MM-dd'), 'en-US-ET');
            if (SLEnrollAggSpecific.field.values[0].value !== null)
                stoplossrow.SLEnrollAggSpecific = friendlyValue(SLEnrollAggSpecific.controlType, SLEnrollAggSpecific.field.values[0].value);
            if (SLAdditionalLiability.field.values[0].value !== null)
                stoplossrow.SLAdditionalLiability = friendlyValue(SLAdditionalLiability.controlType, SLAdditionalLiability.field.values[0].value);
            if (SLSpecificDeductibleAmount.field.values[0].value !== null)
                stoplossrow.SLSpecificDeductibleAmount = friendlyValue(SLSpecificDeductibleAmount.controlType, SLSpecificDeductibleAmount.field.values[0].value);
            if (SLSpecificContractBasis.field.values[0].value !== null)
                stoplossrow.SLSpecificContractBasis = friendlyValue(SLSpecificContractBasis.controlType, SLSpecificContractBasis.field.values[0].value);
            if (SLSpecificIncludeAccessFee.field.values[0].value !== null)
                stoplossrow.SLSpecificIncludeAccessFee = friendlyValue(SLSpecificIncludeAccessFee.controlType, SLSpecificIncludeAccessFee.field.values[0].value);
            if (SLSpecificOtherEnterOther.field.values[0].value !== null)
                stoplossrow.SLSpecificOtherEnterOther = friendlyValue(SLSpecificOtherEnterOther.controlType, SLSpecificOtherEnterOther.field.values[0].value);
            if (SLSpecificMedical.field.values[0].value !== null)
                stoplossrow.SLSpecificMedical = friendlyValue(SLSpecificMedical.controlType, SLSpecificMedical.field.values[0].value);
            if (SLSpecificDrug.field.values[0].value !== null)
                stoplossrow.SLSpecificDrug = friendlyValue(SLSpecificDrug.controlType, SLSpecificDrug.field.values[0].value);
            if (SLSpecificVision.field.values[0].value !== null)
                stoplossrow.SLSpecificVision = friendlyValue(SLSpecificVision.controlType, SLSpecificVision.field.values[0].value);
            if (SLSpecificCarveOutDrug.field.values[0].value !== null)
                stoplossrow.SLSpecificCarveOutDrug = friendlyValue(SLSpecificCarveOutDrug.controlType, SLSpecificCarveOutDrug.field.values[0].value);
            if (SLSpecificDrugsOnCarveOutTable.field.values[0].value !== null)
                stoplossrow.SLSpecificDrugsOnCarveOutTable = friendlyValue(SLSpecificDrugsOnCarveOutTable.controlType, SLSpecificDrugsOnCarveOutTable.field.values[0].value);
            if (SLSpecificPBMVendor.field.values[0].value !== null)
                stoplossrow.SLSpecificPBMVendor = friendlyValue(SLSpecificPBMVendor.controlType, SLSpecificPBMVendor.field.values[0].value);
            if (SLAggregateEnroll.field.values[0].value !== null)
                stoplossrow.SLAggregateEnroll = friendlyValue(SLAggregateEnroll.controlType, SLAggregateEnroll.field.values[0].value);
            if (SLAggregateContractBasis.field.values[0].value !== null)
                stoplossrow.SLAggregateContractBasis = friendlyValue(SLAggregateContractBasis.controlType, SLAggregateContractBasis.field.values[0].value);
            if (SLAggregateEnterOther.field.values[0].value !== null)
                stoplossrow.SLAggregateEnterOther = friendlyValue(SLAggregateEnterOther.controlType, SLAggregateEnterOther.field.values[0].value);
            if (SLAggregateMedical.field.values[0].value !== null)
                stoplossrow.SLAggregateMedical = friendlyValue(SLAggregateMedical.controlType, SLAggregateMedical.field.values[0].value);
            if (SLAggregateDental.field.values[0].value !== null)
                stoplossrow.SLAggregateDental = friendlyValue(SLAggregateDental.controlType, SLAggregateDental.field.values[0].value);
            if (SLAggregateDrug.field.values[0].value !== null)
                stoplossrow.SLAggregateDrug = friendlyValue(SLAggregateDrug.controlType, SLAggregateDrug.field.values[0].value);
            if (SLAggregateVision.field.values[0].value !== null)
                stoplossrow.SLAggregateVision = friendlyValue(SLAggregateVision.controlType, SLAggregateVision.field.values[0].value);
            if (SLMinimumAnnualAttachmentPoint.field.values[0].value !== null)
                stoplossrow.SLMinimumAnnualAttachmentPoint = friendlyValue(SLMinimumAnnualAttachmentPoint.controlType, SLMinimumAnnualAttachmentPoint.field.values[0].value);
            if (SLAttachmentPoint.field.values[0].value !== null)
                stoplossrow.SLAttachmentPoint = friendlyValue(SLAttachmentPoint.controlType, SLAttachmentPoint.field.values[0].value);
            if (SLSingleMedical.field.values[0].value !== null)
                stoplossrow.SLSingleMedical = friendlyValue(SLSingleMedical.controlType, SLSingleMedical.field.values[0].value);
            if (SLFamilyMedical.field.values[0].value !== null)
                stoplossrow.SLFamilyMedical = friendlyValue(SLFamilyMedical.controlType, SLFamilyMedical.field.values[0].value);
            if (SLEECHMedical.field.values[0].value !== null)
                stoplossrow.SLEECHMedical = friendlyValue(SLEECHMedical.controlType, SLEECHMedical.field.values[0].value);
            if (SLEESPMedical.field.values[0].value !== null)
                stoplossrow.SLEESPMedical = friendlyValue(SLEESPMedical.controlType, SLEESPMedical.field.values[0].value);
            if (SLTPMedical.field.values[0].value !== null)
                stoplossrow.SLTPMedical = friendlyValue(SLTPMedical.controlType, SLTPMedical.field.values[0].value);
            if (SLSingleDrug.field.values[0].value !== null)
                stoplossrow.SLSingleDrug = friendlyValue(SLSingleDrug.controlType, SLSingleDrug.field.values[0].value);
            if (SLFamilyDrug.field.values[0].value !== null)
                stoplossrow.SLFamilyDrug = friendlyValue(SLFamilyDrug.controlType, SLFamilyDrug.field.values[0].value);
            if (SLEECHDrug.field.values[0].value !== null)
                stoplossrow.SLEECHDrug = friendlyValue(SLEECHDrug.controlType, SLEECHDrug.field.values[0].value);
            if (SLEESPDrug.field.values[0].value !== null)
                stoplossrow.SLEESPDrug = friendlyValue(SLEESPDrug.controlType, SLEESPDrug.field.values[0].value);
            if (SLSingleDental.field.values[0].value !== null)
                stoplossrow.SLSingleDental = friendlyValue(SLSingleDental.controlType, SLSingleDental.field.values[0].value);
            if (SLFamilyDental.field.values[0].value !== null)
                stoplossrow.SLFamilyDental = friendlyValue(SLFamilyDental.controlType, SLFamilyDental.field.values[0].value);
            if (SLEECHDental.field.values[0].value !== null)
                stoplossrow.SLEECHDental = friendlyValue(SLEECHDental.controlType, SLEECHDental.field.values[0].value);
            if (SLEESPDental.field.values[0].value !== null)
                stoplossrow.SLEESPDental = friendlyValue(SLEESPDental.controlType, SLEESPDental.field.values[0].value);
            if (SLSingleVision.field.values[0].value !== null)
                stoplossrow.SLSingleVision = friendlyValue(SLSingleVision.controlType, SLSingleVision.field.values[0].value);
            if (SLFamilyVision.field.values[0].value !== null)
                stoplossrow.SLFamilyVision = friendlyValue(SLFamilyVision.controlType, SLFamilyVision.field.values[0].value);
            if (SLEECHVision.field.values[0].value !== null)
                stoplossrow.SLEECHVision = friendlyValue(SLEECHVision.controlType, SLEECHVision.field.values[0].value);
            if (SLEESPVision.field.values[0].value !== null)
                stoplossrow.SLEESPVision = friendlyValue(SLEESPVision.controlType, SLEESPVision.field.values[0].value);

            //Stop Loss Packets - 4359dd64-5f09-ee11-8f6e-000d3a305861
            let stopLossPackets = eachStopLoss.attributeSets.filter(q => q.attributeSetRef.id === $matt_$stop_loss_$bcbs_stoplosspackets_id);
            if (stopLossPackets.length > 0) {
                stopLossPackets.forEach(eachPacket => {
                    if (eachPacket.deactivated === false) {
                        let datapacketrow: Record<string, string> = {};
                        const slPacketFields = ArrayToLookupByPredicateWithMap(eachPacket.fields, t => t.configRef.id, t => {
                            const attribute = state.data.config.cache.map_bcbs_config_attribute[t.configRef.id];
                            const masterAttribute = state.data.config.cache.map_bcbs_config_masterattribute[attribute._bcbs_config_masterattributeid_value!];
                            const controlType = masterAttribute.bcbs_attributetypecode as EControlType;
                            return {
                                field: t,
                                attribute,
                                masterAttribute,
                                controlType,
                            }
                        });
                        const SLStopLossPacketsName = slPacketFields[$att_$stop_loss_$bcbs_stoplosspacketname_id];
                        const SLStopLossPacketsCompany = slPacketFields[$att_$stop_loss_$bcbs_stoplosscompany_id];
                        const SLStopLossPacketsEmailAddress = slPacketFields[$att_$stop_loss_$bcbs_stoplossemail_id];
                        if (SLStopLossPacketsEmailAddress.field.values[0].value !== null)
                            datapacketrow.SLStopLossPacketsSLName = eachStopLoss.name;
                        if (SLStopLossPacketsName.field.values[0].value !== null)
                            datapacketrow.SLStopLossPacketsName = friendlyValue(SLStopLossPacketsName.controlType, SLStopLossPacketsName.field.values[0].value);
                        if (SLStopLossPacketsCompany.field.values[0].value !== null)
                            datapacketrow.SLStopLossPacketsCompany = friendlyValue(SLStopLossPacketsCompany.controlType, SLStopLossPacketsCompany.field.values[0].value);
                        if (SLStopLossPacketsEmailAddress.field.values[0].value !== null)
                            datapacketrow.SLStopLossPacketsEmailAddress = friendlyValue(SLStopLossPacketsEmailAddress.controlType, SLStopLossPacketsEmailAddress.field.values[0].value);
                        datapacketrows.push(datapacketrow);
                    }
                });

            }

            //Lasered Individuals - 9ea40129-910f-ee11-8f6d-000d3a305861
            let laseredIndividuals = eachStopLoss.attributeSets.filter(q => q.attributeSetRef.id === $matt_$stop_loss_$bcbs_laseredindividuals_id);
            if (laseredIndividuals.length > 0) {
                laseredIndividuals.forEach(eachIndividual => {
                    if (eachIndividual.deactivated === false) {
                        let individualrow: Record<string, string> = {};
                        const laserFields = ArrayToLookupByPredicateWithMap(eachIndividual.fields, t => t.configRef.id, t => {
                            const attribute = state.data.config.cache.map_bcbs_config_attribute[t.configRef.id];
                            const masterAttribute = state.data.config.cache.map_bcbs_config_masterattribute[attribute._bcbs_config_masterattributeid_value!];
                            const controlType = masterAttribute.bcbs_attributetypecode as EControlType;
                            return {
                                field: t,
                                attribute,
                                masterAttribute,
                                controlType,
                            }
                        });

                        const SLLaserClaimantType = laserFields[$att_$stop_loss_$bcbs_claimant_type_laser_excluded_id];
                        const SLLaserClaimantFirstName = laserFields[$att_$stop_loss_$bcbs_laserclaimantfirstname_id];
                        const SLLaserClaimantLastName = laserFields[$att_$stop_loss_$bcbs_laserclaimantlastname_id];
                        const SLLaserSubscriberSSNAltID = laserFields[$att_$stop_loss_$bcbs_subssnaltid_id];
                        const SLLaserPatientDOB = laserFields[$att_$stop_loss_$bcbs_laserdob_id];
                        const SLLaserSpecificDeductibleAmount = laserFields[$att_$stop_loss_$bcbs_laserspecificdedamt_id];
                        const SLLaserContractBasis = laserFields[$att_$stop_loss_$bcbs_lasercontractbasis_id];
                        if (SLLaserClaimantFirstName.field.values[0].value !== null || SLLaserClaimantLastName.field.values[0].value !== null)
                            individualrow.SLLaserSLName = eachStopLoss.name;
                        if (SLLaserClaimantType.field.values[0].value !== null)
                            individualrow.SLLaserClaimantType = friendlyValue(SLLaserClaimantType.controlType, SLLaserClaimantType.field.values[0].value);
                        if (SLLaserClaimantFirstName.field.values[0].value !== null)
                            individualrow.SLLaserClaimantFirstName = friendlyValue(SLLaserClaimantFirstName.controlType, SLLaserClaimantFirstName.field.values[0].value);
                        if (SLLaserClaimantLastName.field.values[0].value !== null)
                            individualrow.SLLaserClaimantLastName = friendlyValue(SLLaserClaimantLastName.controlType, SLLaserClaimantLastName.field.values[0].value);
                        if (SLLaserSubscriberSSNAltID.field.values[0].value !== null)
                            individualrow.SLLaserSubscriberSSNAltID = friendlyValue(SLLaserSubscriberSSNAltID.controlType, SLLaserSubscriberSSNAltID.field.values[0].value);
                        if (SLLaserPatientDOB.field.values[0].value !== null)
                            individualrow.SLLaserPatientDOB = formatDate(parseDate(friendlyValue(SLLaserPatientDOB.controlType, SLLaserPatientDOB.field.values[0].value), 'local:yyyy-MM-dd'), 'en-US-ET');
                        if (SLLaserSpecificDeductibleAmount.field.values[0].value !== null)
                            individualrow.SLLaserSpecificDeductibleAmount = friendlyValue(SLLaserSpecificDeductibleAmount.controlType, SLLaserSpecificDeductibleAmount.field.values[0].value);
                        if (SLLaserContractBasis.field.values[0].value !== null)
                            individualrow.SLLaserContractBasis = friendlyValue(SLLaserContractBasis.controlType, SLLaserContractBasis.field.values[0].value);
                        laseredrows.push(individualrow);
                    }
                });
            }
            stoplossrows.push(stoplossrow);
        });
    }

    //Fee & Premium Section
    if (data.feesAndPremiums.length > 0) {
        data.feesAndPremiums.forEach(eachFP => {
            let fprow: Record<string, string> = {};
            const fPFields = ArrayToLookupByPredicateWithMap(eachFP.fields, t => t.configRef.id, t => {
                const attribute = state.data.config.cache.map_bcbs_config_attribute[t.configRef.id];
                const masterAttribute = state.data.config.cache.map_bcbs_config_masterattribute[attribute._bcbs_config_masterattributeid_value!];
                const controlType = masterAttribute.bcbs_attributetypecode as EControlType;
                return {
                    field: t,
                    attribute,
                    masterAttribute,
                    controlType,
                }
            });
            const FPBeginningDate = fPFields[$att_$fees_and_premiums_$bcbs_fin_curr_contr_yr_beginning_date_id];
            const FPEndingDate = fPFields[$att_$fees_and_premiums_$bcbs_fin_curr_contr_yr_end_date_id];
            const FPOriginalLOBGroupEffectiveDate = fPFields[$att_$fees_and_premiums_$bcbs_fin_curr_contr_yr_lob_eff_date_id];
            const FPMedicalEffectiveDate = fPFields[$att_$fees_and_premiums_$bcbs_medical_effective_date_id];
            const FPOtherEffectiveDate = fPFields[$att_$fees_and_premiums_$bcbs_other_effective_date_id];
            const FPDentalEffectiveDate = fPFields[$att_$fees_and_premiums_$bcbs_dental_effective_date_id];
            const FPRXEffectiveDate = fPFields[$att_$fees_and_premiums_$bcbs_rx_effective_date_id];
            const FPASOHealthyVisionEffectiveDate = fPFields[$att_$fees_and_premiums_$bcbs_vision_effective_date_id];

            let filteredPlans = data.plans.filter(q => q.feesAndPremiumsRef?.id === eachFP.id);
            //Group Structure
            let groupNumbers: string[] = [];
            data.groupStructure?.groupNumbers?.forEach(q => {
                filteredPlans.forEach(t => {
                    if (q.planRef?.id === t.id) {
                        if (q.groupNumber) {
                            const groupNumber = q.groupNumber;
                            if (q.deactivated === false)
                                groupNumbers.push(groupNumber);
                        }
                    }
                });
            });
            const groupNumbersSort = groupNumbers.sort();
            const prefixBases: string[] = [];
            if (groupNumbersSort.length > 0) {
                let prefixbaseNumber = groupNumbers[0].substring(0, 8);
                prefixBases.push(prefixbaseNumber);
                groupNumbersSort.forEach(function (item, index) {
                    if (item.substring(0, 8) !== prefixbaseNumber) {
                        prefixbaseNumber = item.substring(0, 8);
                        prefixBases.push(prefixbaseNumber);
                    }
                });

            }

            if (prefixBases.length === 1) {
                fprow.FPprefixbase = prefixBases[0];
                let suffixes = "";
                groupNumbersSort.forEach(function (item, index) {
                    if (index === groupNumbersSort.length - 1)
                        suffixes += groupNumbersSort[index].substring(9, 11);
                    else
                        suffixes += groupNumbersSort[index].substring(9, 11) + ", ";
                });
                //suffixes.replace(", ")
                fprow.FPsuffixes = suffixes;

            }
            else if (prefixBases.length > 1) {
                let fpprefixBaseNumbers = "";
                let suffixes = "";
                prefixBases.forEach(function (item, index) {
                    if (index === prefixBases.length - 1)
                        fpprefixBaseNumbers += item;
                    else
                        fpprefixBaseNumbers += item + ",";
                    groupNumbersSort.forEach(function (suffixitem, suffixindex) {
                        if (suffixitem.substring(0, 8) === item) {
                            if (suffixindex === groupNumbersSort.length - 1)
                                suffixes += suffixitem;
                            else
                                suffixes += suffixitem + ", ";
                        }
                    });
                });
                fprow.FPprefixbase = fpprefixBaseNumbers;
                fprow.FPsuffixes = suffixes;

            }

            fprow.FPName = eachFP.name;
            if (FPBeginningDate.field.values[0].value !== null)
                fprow.FPBeginningDate = formatDate(parseDate(friendlyValue(FPBeginningDate.controlType, FPBeginningDate.field.values[0].value), 'local:yyyy-MM-dd'), 'en-US-ET');
            if (FPEndingDate.field.values[0].value !== null)
                fprow.FPEndingDate = formatDate(parseDate(friendlyValue(FPEndingDate.controlType, FPEndingDate.field.values[0].value), 'local:yyyy-MM-dd'), 'en-US-ET');
            if (FPOriginalLOBGroupEffectiveDate.field.values[0].value !== null)
                fprow.FPOriginalLOBGroupEffectiveDate = formatDate(parseDate(friendlyValue(FPOriginalLOBGroupEffectiveDate.controlType, FPOriginalLOBGroupEffectiveDate.field.values[0].value), 'local:yyyy-MM-dd'), 'en-US-ET');
            if (FPMedicalEffectiveDate.field.values[0].value !== null)
                fprow.FPMedicalEffectiveDate = formatDate(parseDate(friendlyValue(FPMedicalEffectiveDate.controlType, FPMedicalEffectiveDate.field.values[0].value), 'local:yyyy-MM-dd'), 'en-US-ET');
            if (FPOtherEffectiveDate.field.values[0].value !== null)
                fprow.FPOtherEffectiveDate = formatDate(parseDate(friendlyValue(FPOtherEffectiveDate.controlType, FPOtherEffectiveDate.field.values[0].value), 'local:yyyy-MM-dd'), 'en-US-ET');
            if (FPDentalEffectiveDate.field.values[0].value !== null)
                fprow.FPDentalEffectiveDate = formatDate(parseDate(friendlyValue(FPDentalEffectiveDate.controlType, FPDentalEffectiveDate.field.values[0].value), 'local:yyyy-MM-dd'), 'en-US-ET');
            if (FPRXEffectiveDate.field.values[0].value !== null)
                fprow.FPRXEffectiveDate = formatDate(parseDate(friendlyValue(FPRXEffectiveDate.controlType, FPRXEffectiveDate.field.values[0].value), 'local:yyyy-MM-dd'), 'en-US-ET');
            if (FPASOHealthyVisionEffectiveDate.field.values[0].value !== null)
                fprow.FPASOHealthyVisionEffectiveDate = formatDate(parseDate(friendlyValue(FPASOHealthyVisionEffectiveDate.controlType, FPASOHealthyVisionEffectiveDate.field.values[0].value), 'local:yyyy-MM-dd'), 'en-US-ET');

            //Fees
            //data.feesAndPremiums[0].attributeSets
            let hraFee = eachFP.attributeSets.filter(q => q.attributeSetRef.id === $matt_$fees_and_premiums_$bcbs_attributeset_fee_id && q.deactivated === false).filter(t => t.fields.some(u => u.configRef.id === $att_$fees_and_premiums_$bcbs_bccadminid_id&& (u.values[0]?.value as FAM_IEntityReferenceValue)?.name?.includes('HRA')));
            let caFee = eachFP.attributeSets.filter(q => q.attributeSetRef.id === $matt_$fees_and_premiums_$bcbs_attributeset_fee_id && q.deactivated === false).filter(t => t.fields.some(u => u.configRef.id === $att_$fees_and_premiums_$bcbs_bccadminid_id && (u.values[0]?.value as FAM_IEntityReferenceValue)?.name?.includes('CA1')));
            let baFee = eachFP.attributeSets.filter(q => q.attributeSetRef.id === $matt_$fees_and_premiums_$bcbs_attributeset_fee_id && q.deactivated === false).filter(t => t.fields.some(u => u.configRef.id === $att_$fees_and_premiums_$bcbs_bccadminid_id && (u.values[0]?.value as FAM_IEntityReferenceValue)?.name?.includes('BA1')));
            let raFee = eachFP.attributeSets.filter(q => q.attributeSetRef.id === $matt_$fees_and_premiums_$bcbs_attributeset_fee_id && q.deactivated === false).filter(t => t.fields.some(u => u.configRef.id === $att_$fees_and_premiums_$bcbs_bccadminid_id && (u.values[0]?.value as FAM_IEntityReferenceValue)?.name?.includes('RA1')));

            if (hraFee.length > 0) {
                const hraFields = ArrayToLookupByPredicateWithMap(hraFee[0].fields, t => t.configRef.id, t => {
                    const attribute = state.data.config.cache.map_bcbs_config_attribute[t.configRef.id];
                    const masterAttribute = state.data.config.cache.map_bcbs_config_masterattribute[attribute._bcbs_config_masterattributeid_value!];
                    const controlType = masterAttribute.bcbs_attributetypecode as EControlType;
                    return {
                        field: t,
                        attribute,
                        masterAttribute,
                        controlType,
                    }
                });
                const HRAFeeType = hraFields[$att_$fees_and_premiums_$bcbs_fee_feetype_id];
                const HRAOtherFeeType = hraFields[$att_$fees_and_premiums_$bcbs_fee_otherfeetype_id];
                const HRAFeeAmount = hraFields[$att_$fees_and_premiums_$bcbs_fee_feeamount_id];
                const HRABillGroup = hraFields[$att_$fees_and_premiums_$bcbs_billgroupcode_id];
                const HRAShowAsSeparateItemOnBill = hraFields[$att_$fees_and_premiums_$bcbs_showasseparateitemonbill_id];
                const HRABCBSSCOtherSplit = hraFields[$att_$fees_and_premiums_$bcbs_scothersplit_id];
                if (HRAFeeType.field.values[0].value !== null)
                    fprow.HRAFeeType = friendlyValue(HRAFeeType.controlType, HRAFeeType.field.values[0].value);
                if (HRAOtherFeeType.field.values[0].value !== null)
                    fprow.HRAOtherFeeType = friendlyValue(HRAOtherFeeType.controlType, HRAOtherFeeType.field.values[0].value);
                if (HRAFeeAmount.field.values[0].value !== null)
                    fprow.HRAFeeAmount = friendlyValue(HRAFeeAmount.controlType, HRAFeeAmount.field.values[0].value);
                if (HRABillGroup.field.values[0].value !== null)
                    fprow.HRABillGroup = friendlyValue(HRABillGroup.controlType, HRABillGroup.field.values[0].value);
                if (HRAShowAsSeparateItemOnBill.field.values[0].value !== null)
                    fprow.HRAShowAsSeparateItemOnBill = friendlyValue(HRAShowAsSeparateItemOnBill.controlType, HRAShowAsSeparateItemOnBill.field.values[0].value);
                if (HRABCBSSCOtherSplit.field.values[0].value !== null)
                    fprow.HRABCBSSCOtherSplit = friendlyValue(HRABCBSSCOtherSplit.controlType, HRABCBSSCOtherSplit.field.values[0].value);
            }
            if (caFee.length > 0) {
                const caFields = ArrayToLookupByPredicateWithMap(caFee[0].fields, t => t.configRef.id, t => {
                    const attribute = state.data.config.cache.map_bcbs_config_attribute[t.configRef.id];
                    const masterAttribute = state.data.config.cache.map_bcbs_config_masterattribute[attribute._bcbs_config_masterattributeid_value!];
                    const controlType = masterAttribute.bcbs_attributetypecode as EControlType;
                    return {
                        field: t,
                        attribute,
                        masterAttribute,
                        controlType,
                    }
                });
                const CA1FeeType = caFields[$att_$fees_and_premiums_$bcbs_fee_feetype_id];
                const CA1OtherFeeType = caFields[$att_$fees_and_premiums_$bcbs_fee_otherfeetype_id];
                const CA1FeeAmount = caFields[$att_$fees_and_premiums_$bcbs_fee_feeamount_id];
                const CA1BillGroup = caFields[$att_$fees_and_premiums_$bcbs_billgroupcode_id];
                const CA1ShowAsSeparateItemOnBill = caFields[$att_$fees_and_premiums_$bcbs_showasseparateitemonbill_id];
                const CA1BCBSSCOtherSplit = caFields[$att_$fees_and_premiums_$bcbs_scothersplit_id];
                if (CA1FeeType.field.values[0].value !== null)
                    fprow.CA1FeeType = friendlyValue(CA1FeeType.controlType, CA1FeeType.field.values[0].value);
                if (CA1OtherFeeType.field.values[0].value !== null)
                    fprow.CA1OtherFeeType = friendlyValue(CA1OtherFeeType.controlType, CA1OtherFeeType.field.values[0].value);
                if (CA1FeeAmount.field.values[0].value !== null)
                    fprow.CA1FeeAmount = friendlyValue(CA1FeeAmount.controlType, CA1FeeAmount.field.values[0].value);
                if (CA1BillGroup.field.values[0].value !== null)
                    fprow.CA1BillGroup = friendlyValue(CA1BillGroup.controlType, CA1BillGroup.field.values[0].value);
                if (CA1ShowAsSeparateItemOnBill.field.values[0].value !== null)
                    fprow.CA1ShowAsSeparateItemOnBill = friendlyValue(CA1ShowAsSeparateItemOnBill.controlType, CA1ShowAsSeparateItemOnBill.field.values[0].value);
                if (CA1BCBSSCOtherSplit.field.values[0].value !== null)
                    fprow.CA1BCBSSCOtherSplit = friendlyValue(CA1BCBSSCOtherSplit.controlType, CA1BCBSSCOtherSplit.field.values[0].value);
            }
            if (baFee.length > 0) {
                const baFields = ArrayToLookupByPredicateWithMap(baFee[0].fields, t => t.configRef.id, t => {
                    const attribute = state.data.config.cache.map_bcbs_config_attribute[t.configRef.id];
                    const masterAttribute = state.data.config.cache.map_bcbs_config_masterattribute[attribute._bcbs_config_masterattributeid_value!];
                    const controlType = masterAttribute.bcbs_attributetypecode as EControlType;
                    return {
                        field: t,
                        attribute,
                        masterAttribute,
                        controlType,
                    }
                });
                const BA1FeeType = baFields[$att_$fees_and_premiums_$bcbs_fee_feetype_id];
                const BA1OtherFeeType = baFields[$att_$fees_and_premiums_$bcbs_fee_otherfeetype_id];
                const BA1FeeAmount = baFields[$att_$fees_and_premiums_$bcbs_fee_feeamount_id];
                const BA1BillGroup = baFields[$att_$fees_and_premiums_$bcbs_billgroupcode_id];
                const BA1ShowAsSeparateItemOnBill = baFields[$att_$fees_and_premiums_$bcbs_showasseparateitemonbill_id];
                const BA1BCBSSCOtherSplit = baFields[$att_$fees_and_premiums_$bcbs_scothersplit_id];
                if (BA1FeeType.field.values[0].value !== null)
                    fprow.BA1FeeType = friendlyValue(BA1FeeType.controlType, BA1FeeType.field.values[0].value);
                if (BA1OtherFeeType.field.values[0].value !== null)
                    fprow.BA1OtherFeeType = friendlyValue(BA1OtherFeeType.controlType, BA1OtherFeeType.field.values[0].value);
                if (BA1FeeAmount.field.values[0].value !== null)
                    fprow.BA1FeeAmount = friendlyValue(BA1FeeAmount.controlType, BA1FeeAmount.field.values[0].value);
                if (BA1BillGroup.field.values[0].value !== null)
                    fprow.BA1BillGroup = friendlyValue(BA1BillGroup.controlType, BA1BillGroup.field.values[0].value);
                if (BA1ShowAsSeparateItemOnBill.field.values[0].value !== null)
                    fprow.BA1ShowAsSeparateItemOnBill = friendlyValue(BA1ShowAsSeparateItemOnBill.controlType, BA1ShowAsSeparateItemOnBill.field.values[0].value);
                if (BA1BCBSSCOtherSplit.field.values[0].value !== null)
                    fprow.BA1BCBSSCOtherSplit = friendlyValue(BA1BCBSSCOtherSplit.controlType, BA1BCBSSCOtherSplit.field.values[0].value);
            }
            if (raFee.length > 0) {
                //let fieldsTest = getFeeValues(raFee);
                const raFields = ArrayToLookupByPredicateWithMap(raFee[0].fields, t => t.configRef.id, t => {
                    const attribute = state.data.config.cache.map_bcbs_config_attribute[t.configRef.id];
                    const masterAttribute = state.data.config.cache.map_bcbs_config_masterattribute[attribute._bcbs_config_masterattributeid_value!];
                    const controlType = masterAttribute.bcbs_attributetypecode as EControlType;
                    return {
                        field: t,
                        attribute,
                        masterAttribute,
                        controlType,
                    }
                });
                const RA1FeeType = raFields[$att_$fees_and_premiums_$bcbs_fee_feetype_id];
                const RA1OtherFeeType = raFields[$att_$fees_and_premiums_$bcbs_fee_otherfeetype_id];
                const RA1FeeAmount = raFields[$att_$fees_and_premiums_$bcbs_fee_feeamount_id];
                const RA1BillGroup = raFields[$att_$fees_and_premiums_$bcbs_billgroupcode_id];
                const RA1ShowAsSeparateItemOnBill = raFields[$att_$fees_and_premiums_$bcbs_showasseparateitemonbill_id];
                const RA1BCBSSCOtherSplit = raFields[$att_$fees_and_premiums_$bcbs_scothersplit_id];
                if (RA1FeeType.field.values[0].value !== null)
                    fprow.RA1FeeType = friendlyValue(RA1FeeType.controlType, RA1FeeType.field.values[0].value);
                if (RA1OtherFeeType.field.values[0].value !== null)
                    fprow.RA1OtherFeeType = friendlyValue(RA1OtherFeeType.controlType, RA1OtherFeeType.field.values[0].value);
                if (RA1FeeAmount.field.values[0].value !== null)
                    fprow.RA1FeeAmount = friendlyValue(RA1FeeAmount.controlType, RA1FeeAmount.field.values[0].value);
                if (RA1BillGroup.field.values[0].value !== null)
                    fprow.RA1BillGroup = friendlyValue(RA1BillGroup.controlType, RA1BillGroup.field.values[0].value);
                if (RA1ShowAsSeparateItemOnBill.field.values[0].value !== null)
                    fprow.RA1ShowAsSeparateItemOnBill = friendlyValue(RA1ShowAsSeparateItemOnBill.controlType, RA1ShowAsSeparateItemOnBill.field.values[0].value);
                if (RA1BCBSSCOtherSplit.field.values[0].value !== null)
                    fprow.RA1BCBSSCOtherSplit = friendlyValue(RA1BCBSSCOtherSplit.controlType, RA1BCBSSCOtherSplit.field.values[0].value);

            }
            fprows.push(fprow);
        });
    }




    rows.push(row);

    state.data.json.benefits.forEach(eachBenefit => {

        const benefitPlans = state.data.json.plans.filter(eachPlan => eachPlan.benefitRefs.find(q => q.id === eachBenefit.id));

        // benefit part of a plan, we need to duplicate
        //if (benefitPlans?.length > 0)
        //    benefitPlans.forEach(eachPlan => {
        //        eachBenefit.nonStandards.forEach(eachNS => {
        //            const row = nonStandardToRow({ plan: eachPlan, benefit: eachBenefit, groupConfig: state.data.json, nonStandard: eachNS });
        //            rows.push(row);
        //        });
        //    });
        //else
        //    eachBenefit.nonStandards.forEach(eachNS => {
        //        const row = nonStandardToRow({ benefit: eachBenefit, groupConfig: state.data.json, nonStandard: eachNS });
        //        rows.push(row);
        //    });

    });

    state.data.json.nonStandards.forEach(eachNS => {
        //const row = nonStandardToRow({ groupConfig: state.data.json, nonStandard: eachNS });
        //rows.push(row);
    });

    const columnsArray = Object.entries(columns).map(kv => kv[1]);
    const claimsarcolumnsArray = Object.entries(claimsarcolumns).map(kv => kv[1]);
    const perscriptcolumnsArray = Object.entries(perscriptcolumns).map(kv => kv[1]);
    const contactcolumnsArray = Object.entries(contactcolumns).map(kv => kv[1]);
    const stoplosscolumnsArray = Object.entries(stoplosscolumns).map(kv => kv[1]);
    const datapacketscolumnsArray = Object.entries(datapacketcolumns).map(kv => kv[1]);
    const laseredcolumnsArray = Object.entries(laseredcolumns).map(kv => kv[1]);
    const feesandpremiumscolumnsArray = Object.entries(fpcolumns).map(kv => kv[1]);

    let verticalarcolumns: Record<string, IColumnExtract> = {};
    let verticalarcolumnIX = 0;
    verticalarcolumns['Attributes'] = {
        attributeId: '',
        order: 0,
        width: 45,
        index: ++verticalarcolumnIX,
        fieldName: 'Attributes',
        hidden: false,
        name: 'Attributes',
        dataType: EColumnExtractDataTypes.Default,
    };
    if (claimsarrows.length > 0) {
        claimsarrows.forEach((eachrow, index) => {
            let columnname = 'Record' + (index + 1);
            verticalarcolumns[columnname] = {
                attributeId: '',
                order: 0,
                width: 45,
                index: ++verticalarcolumnIX,
                fieldName: columnname,
                hidden: false,
                name: columnname,
                dataType: EColumnExtractDataTypes.Default,
            };

        });
    }
    const verticalarrows: IRowExtract[] = [];
    claimsarcolumnsArray.forEach(eachColumn => {
        //Add each column as a row and then map all data to the corresponding row
        let claimsarrow: IRowExtract = {};
        claimsarrow.Attributes = eachColumn.name;
        claimsarrows.forEach((eachrow, index) => {
            let columnname = 'Record' + ((index ?? 0) + 1);
            //if (columnname === undefined)
            //columnname = 'Record1';
            if (eachrow[eachColumn.fieldName] !== undefined) {
                claimsarrow[columnname] = eachrow[eachColumn.fieldName];
            }


        });
        verticalarrows.push(claimsarrow);
    });

    let verticalslcolumns: Record<string, IColumnExtract> = {};
    let verticalslcolumnIX = 0;
    verticalslcolumns['Attributes'] = {
        attributeId: '',
        order: 0,
        width: 45,
        index: ++verticalslcolumnIX,
        fieldName: 'Attributes',
        hidden: false,
        name: 'Attributes',
        dataType: EColumnExtractDataTypes.Default,
    };
    if (stoplossrows.length > 0) {
        stoplossrows.forEach((eachrow, index) => {
            let columnname = 'Record' + (index + 1);
            verticalslcolumns[columnname] = {
                attributeId: '',
                order: 0,
                width: 45,
                index: ++verticalslcolumnIX,
                fieldName: columnname,
                hidden: false,
                name: columnname,
                dataType: EColumnExtractDataTypes.Default,
            };

        });
    }
    const verticalstoplossrows: IRowExtract[] = [];
    stoplosscolumnsArray.forEach(eachColumn => {
        //Add each column as a row and then map all data to the corresponding row
        let slrow: IRowExtract = {};
        slrow.Attributes = eachColumn.name;
        stoplossrows.forEach((eachrow, index) => {
            let columnname = 'Record' + (index + 1);
            if (columnname === undefined)
                columnname = 'Record1';
            if (eachrow[eachColumn.fieldName] !== undefined) {
                slrow[columnname] = eachrow[eachColumn.fieldName];
            }


        });
        verticalstoplossrows.push(slrow);
    });

    let verticalfpcolumns: Record<string, IColumnExtract> = {};
    let verticalfpcolumnIX = 0;
    verticalfpcolumns['Attributes'] = {
        attributeId: '',
        order: 0,
        width: 45,
        index: ++verticalfpcolumnIX,
        fieldName: 'Attributes',
        hidden: false,
        name: 'Attributes',
        dataType: EColumnExtractDataTypes.Default,
    };
    if (fprows.length > 0) {
        fprows.forEach((eachrow, index) => {
            let columnname = 'Record' + (index + 1);
            verticalfpcolumns[columnname] = {
                attributeId: '',
                order: 0,
                width: 45,
                index: ++verticalfpcolumnIX,
                fieldName: columnname,
                hidden: false,
                name: columnname,
                dataType: EColumnExtractDataTypes.Default,
            };

        });
    }
    const verticalfprows: IRowExtract[] = [];
    feesandpremiumscolumnsArray.forEach(eachColumn => {
        //Add each column as a row and then map all data to the corresponding row
        let fprow: IRowExtract = {};
        fprow.Attributes = eachColumn.name;
        fprows.forEach((eachrow, index) => {
            let columnname = 'Record' + (index + 1);
            if (columnname === undefined)
                columnname = 'Record1';
            if (eachrow[eachColumn.fieldName] !== undefined) {
                fprow[columnname] = eachrow[eachColumn.fieldName];
            }


        });
        verticalfprows.push(fprow);
    });




    const verticalarColumnsArray = Object.entries(verticalarcolumns).map(kv => kv[1]);
    const verticalslColumnsArray = Object.entries(verticalslcolumns).map(kv => kv[1]);
    const verticalfpColumnsArray = Object.entries(verticalfpcolumns).map(kv => kv[1]);

    const dataSet: IDatasetExtract = {
        name: '',
        tables: [
            {
                columns: columnsArray,
                data: rows,
                name: "Financial Extract"
            },
            {
                columns: verticalarColumnsArray,
                data: verticalarrows,
                name: "Claims AR"
            },
            {
                columns: perscriptcolumnsArray,
                data: perscriptrows,
                name: "Per Script Fees"
            },
            {
                columns: contactcolumnsArray,
                data: contactrows,
                name: "Contacts"
            },
            {
                columns: verticalslColumnsArray,
                data: verticalstoplossrows,
                name: "Stop Loss"
            },
            {
                columns: datapacketscolumnsArray,
                data: datapacketrows,
                name: "Data Packets"
            },
            {
                columns: laseredcolumnsArray,
                data: laseredrows,
                name: "Lasered Individuals"
            },
            {
                columns: verticalfpColumnsArray,
                data: verticalfprows,
                name: "Fees and Premiums"
            }
        ],
        dropDownTables: null
    }

    //{
    //    columns: claimsarcolumnsArray,
    //        data: claimsarrows,
    //            name: "Claims AR"
    //},
    const getFinancialExtractAsync = await dataSource.getGenerateExcelExtract(dataSet);
    return getFinancialExtractAsync;

}